(function () {
  'use strict';

  if (window.SwishPreviewColumnOrdering) {
    window.SwishPreviewColumnOrdering.init(document);
    return;
  }

  var cardsByMessageId = Object.create(null);
  var builderMarkupByUrl = Object.create(null);
  var sharedEditorFrame = null;
  var sharedEditorSourceUrl = '';
  var sharedEditorDocumentPromise = null;
  var sharedEditorActiveEntry = null;
  var sharedEditorLoadSequence = 0;
  var sharedEditorQueue = Promise.resolve();
  var previewOrbitGesture = null;
  // Main Court Builder: 0.0375 degrees per 60 Hz frame = 2.25 degrees/second.
  var PREVIEW_ORDER_ROTATE_DEG_PER_SEC = 0.0375 * 60;
  var PREVIEW_BASKETBALL_ARC_IDS = ['left', 'right', 'top', 'bottom'].reduce(function (ids, side) {
    return ids.concat(side + 'FreeThrowHalfCircleLine', side + 'RestrictedAreaLine');
  }, []);
  var logoEditorPositionFrame = 0;
  var logoEditorResizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(function () { scheduleLogoEditorPosition(); })
    : null;

  // The logo editor is anchored to its column item and scrolls with it.
  // Only size changes require recalculating its overlay geometry.
  function scheduleLogoEditorPosition() {
    if (!sharedEditorActiveEntry || !sharedEditorActiveEntry.logoEditorActive || logoEditorPositionFrame) return;
    logoEditorPositionFrame = requestAnimationFrame(function () {
      logoEditorPositionFrame = 0;
      if (sharedEditorActiveEntry && sharedEditorActiveEntry.logoEditorActive) {
        positionLogoEditor(sharedEditorActiveEntry);
      }
    });
  }

  window.addEventListener('resize', scheduleLogoEditorPosition, { passive: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleLogoEditorPosition, { passive: true });
  var planResizeFrame = 0;
  var planResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function () {
    if (planResizeFrame) cancelAnimationFrame(planResizeFrame);
    planResizeFrame = requestAnimationFrame(function () {
      planResizeFrame = 0;
      requestPlanPreview(sharedEditorActiveEntry);
    });
  }) : null;

  function escapeAttribute(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function parseHash(hash) {
    var raw = String(hash || '').replace(/^#/, '');
    var marker = raw.indexOf('swishcb=');
    if (marker >= 0) raw = raw.slice(marker);
    var params = new URLSearchParams(raw);
    return { raw: raw, params: params };
  }

  function setHashView(hash, view) {
    var parsed = parseHash(hash);
    parsed.params.set('view', view || '2d');
    return parsed.params.toString();
  }

  function previewBasketballLineHash(card, hash) {
    // Identify compact presets from their configured dimensions before customer
    // edits, including the explicitly configured U.S. 13 x 23 ft court.
    var reference = parseHash(card.dataset.swishPreviewOrderReferenceHash || card.dataset.swishPreviewOrderHash);
    var factor = reference.params.get('u') === 'ft' ? 0.3048 : 1;
    var width = Number(reference.params.get('w')) * factor;
    var length = Number(reference.params.get('l')) * factor;
    var shortSide = Math.min(width, length);
    var longSide = Math.max(width, length);
    var compact = (Math.abs(longSide - 7) < 0.01 &&
      (Math.abs(shortSide - 3) < 0.01 || Math.abs(shortSide - 4) < 0.01)) ||
      (reference.params.get('u') === 'ft' && Math.abs(longSide - 23 * 0.3048) < 0.01 &&
        Math.abs(shortSide - 13 * 0.3048) < 0.01);
    var parsed = parseHash(hash);
    var hidden = String(parsed.params.get('dv') || '').split(',').filter(function (id) {
      return id && PREVIEW_BASKETBALL_ARC_IDS.indexOf(id) < 0;
    });
    if (compact) hidden = hidden.concat(PREVIEW_BASKETBALL_ARC_IDS);
    if (hidden.length) parsed.params.set('dv', hidden.join(','));
    else parsed.params.delete('dv');
    return parsed.params.toString();
  }

  function setEngineHash(hash) {
    var parsed = parseHash(hash);
    parsed.params.set('view', '2d');
    parsed.params.set('ar', '0');
    return parsed.params.toString();
  }

  function restoreDesignView(hash, originalHash) {
    var original = parseHash(originalHash);
    var parsed = parseHash(hash);
    parsed.params.set('view', original.params.get('view') || '3d');
    // The hidden order editor forces ar=0. Restore the preset's choice, or the
    // full builder's rotating default, instead of leaking that temporary pause.
    parsed.params.set('ar', original.params.get('ar') || '1');
    return parsed.params.toString();
  }

  function applyPreviewLogoManifest(entry, hash, logos) {
    var parsed = parseHash(hash);
    var safeLogos = Array.isArray(logos) ? logos.map(function (logo) {
      var widthM = Number(logo && logo.widthM);
      var heightM = Number(logo && logo.heightM);
      var url = String(logo && logo.url || '').trim();
      if (!url || !(widthM > 0) || !(heightM > 0)) return null;
      return {
        id: String(logo.id || ''),
        url: url,
        widthM: widthM,
        heightM: heightM,
        x: Number.isFinite(Number(logo.x)) ? Number(logo.x) : 0,
        y: Number.isFinite(Number(logo.y)) ? Number(logo.y) : 0,
        rotation: Number.isFinite(Number(logo.rotation)) ? Number(logo.rotation) : 0
      };
    }).filter(Boolean) : [];
    var previousUrl = entry && entry.previewLogoManifestUrl;
    var signature = safeLogos.length ? JSON.stringify(safeLogos) : '';

    if (safeLogos.length && entry) {
      if (entry.previewLogoManifestSignature !== signature || !entry.previewLogoManifestUrl) {
        var blob = new Blob([JSON.stringify({ logos: safeLogos })], { type: 'application/json' });
        entry.previewLogoManifestUrl = URL.createObjectURL(blob);
        entry.previewLogoManifestSignature = signature;
      }
      parsed.params.set('lu', entry.previewLogoManifestUrl);
    } else {
      if (entry) entry.previewLogoManifestUrl = '';
      if (entry) entry.previewLogoManifestSignature = '';
      parsed.params.delete('lu');
    }

    if (previousUrl && previousUrl !== (entry && entry.previewLogoManifestUrl)) {
      window.setTimeout(function () {
        try { URL.revokeObjectURL(previousUrl); } catch (_) {}
      }, 5000);
    }
    return parsed.params.toString();
  }

  function collectThemeFoundationMarkup() {
    var base = document.head.querySelector('link[rel="stylesheet"][href*="/assets/base.css"]');
    var help = document.querySelector('link[rel="stylesheet"][href*="/assets/swishcb-preview-summary-help.css"]');
    var variables = Array.prototype.find.call(document.head.querySelectorAll('style'), function (style) {
      return String(style.textContent || '').indexOf('--font-body-family') >= 0;
    });
    return (base ? base.outerHTML : '') + (variables ? variables.outerHTML : '') + (help ? help.outerHTML : '');
  }

  function overhangHelpMarkup() {
    var copy = 'Enter your hoop overhang to get precise basketball lines. Find it in your hoopâ€™s manual or online, or measure horizontally from the front edge of the hoop base to the front face of the backboard.';
    return '<button type="button" class="swish-preview-overhang-help" data-swish-preview-overhang-help="' + copy + '"' +
      ' aria-label="Hoop overhang help" aria-description="' + copy + '">' +
      '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M10 9v6"/><circle cx="10" cy="6" r=".8" fill="currentColor" stroke="none"/></svg></button>';
  }

  var summaryHelp = { bubble: null, trigger: null, source: null, pinned: false, timer: 0 };
  function hideSummaryHelp() {
    clearTimeout(summaryHelp.timer);
    if (summaryHelp.bubble) summaryHelp.bubble.hidden = true;
    if (summaryHelp.trigger) summaryHelp.trigger.removeAttribute('aria-describedby');
    summaryHelp.trigger = null;
    summaryHelp.source = null;
    summaryHelp.pinned = false;
  }
  function positionSummaryHelp() {
    var trigger = summaryHelp.trigger, source = summaryHelp.source, bubble = summaryHelp.bubble;
    if (!trigger || !trigger.isConnected || (source !== window && !source.frameElement?.isConnected)) {
      hideSummaryHelp();
      return;
    }
    var r = trigger.getBoundingClientRect();
    var frame = source !== window ? source.frameElement.getBoundingClientRect() : { left: 0, top: 0 };
    var left = r.left + frame.left, top = r.top + frame.top, bottom = r.bottom + frame.top;
    if (bottom < 0 || top > innerHeight) { hideSummaryHelp(); return; }
    var b = bubble.getBoundingClientRect();
    bubble.style.left = Math.max(12, Math.min(innerWidth - b.width - 12, left + r.width / 2 - b.width / 2)) + 'px';
    bubble.style.top = Math.max(12, Math.min(innerHeight - b.height - 12, top - b.height - 8 >= 12 ? top - b.height - 8 : bottom + 8)) + 'px';
  }
  function showSummaryHelp(trigger, source) {
    clearTimeout(summaryHelp.timer);
    if (!summaryHelp.bubble) {
      var bubble = document.createElement('div');
      bubble.id = 'swish-preview-summary-tooltip';
      bubble.className = 'swish-preview-summary-tooltip';
      bubble.setAttribute('role', 'tooltip');
      document.body.appendChild(bubble);
      bubble.addEventListener('pointerenter', function () { clearTimeout(summaryHelp.timer); });
      bubble.addEventListener('pointerleave', function () { if (!summaryHelp.pinned) hideSummaryHelp(); });
      summaryHelp.bubble = bubble;
    }
    if (summaryHelp.trigger && summaryHelp.trigger !== trigger) hideSummaryHelp();
    summaryHelp.trigger = trigger;
    summaryHelp.source = source;
    summaryHelp.bubble.textContent = trigger.dataset.swishPreviewOverhangHelp;
    summaryHelp.bubble.hidden = false;
    // Keep the visual tooltip outside the editor iframe so it cannot be clipped.
    // aria-description supplies the same help inside either document.
    if (source === window) trigger.setAttribute('aria-describedby', summaryHelp.bubble.id);
    positionSummaryHelp();
  }
  function bindSummaryHelp(source) {
    var doc = source.document;
    if (doc.__swishPreviewSummaryHelpBound) return;
    doc.__swishPreviewSummaryHelpBound = true;
    var find = function (node) { return node && node.closest ? node.closest('[data-swish-preview-overhang-help]') : null; };
    doc.addEventListener('pointerover', function (event) {
      var trigger = find(event.target);
      if (trigger && event.pointerType !== 'touch') showSummaryHelp(trigger, source);
    });
    doc.addEventListener('pointerout', function (event) {
      var trigger = find(event.target);
      if (trigger && !trigger.contains(event.relatedTarget) && !summaryHelp.pinned && doc.activeElement !== trigger) {
        summaryHelp.timer = setTimeout(hideSummaryHelp, 150);
      }
    });
    doc.addEventListener('focusin', function (event) {
      var trigger = find(event.target);
      if (trigger) showSummaryHelp(trigger, source);
      else if (summaryHelp.source === source) hideSummaryHelp();
    });
    doc.addEventListener('focusout', function (event) {
      if (find(event.target) && !summaryHelp.pinned) summaryHelp.timer = setTimeout(hideSummaryHelp, 150);
    });
    doc.addEventListener('click', function (event) {
      var trigger = find(event.target);
      if (trigger) {
        if (summaryHelp.trigger === trigger && summaryHelp.pinned) hideSummaryHelp();
        else { showSummaryHelp(trigger, source); summaryHelp.pinned = true; }
      } else if (!summaryHelp.bubble || !summaryHelp.bubble.contains(event.target)) hideSummaryHelp();
    });
    doc.addEventListener('keydown', function (event) { if (event.key === 'Escape') hideSummaryHelp(); });
    source.addEventListener('pagehide', function () { if (summaryHelp.source === source) hideSummaryHelp(); });
  }
  window.addEventListener('scroll', function () { if (summaryHelp.trigger) positionSummaryHelp(); }, { capture: true, passive: true });
  window.addEventListener('resize', hideSummaryHelp);

  function buildDesignUrl(baseUrl, hash) {
    // The builder opens with Total only; card/plan rendering keeps its own mask.
    var launchHash = String(hash || '').replace(/^#/, '');
    launchHash = /(?:^|&)ms=/.test(launchHash)
      ? launchHash.replace(/(^|&)ms=[^&]*/g, '$1ms=1')
      : launchHash + '&ms=1';
    try {
      var url = new URL(String(baseUrl || ''), window.location.href);
      url.hash = launchHash;
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return String(baseUrl || '').split('#')[0] + '#' + launchHash;
    }
  }

  function updateDesignLinks(card, hash) {
    var item = card.closest('.swish-preview-column__item');
    var href = buildDesignUrl(card.dataset.swishPreviewOrderDesignUrl || '', hash);
    // The preview is outside the order summary, inside its preview stage.
    // Both entry points must carry the same current court configuration.
    Array.prototype.forEach.call((item || card).querySelectorAll(
      '[data-swish-preview-order-design], [data-swish-preview-order-preview-link], [data-swish-preview-order-plan-link]'
    ), function (link) {
      link.setAttribute('href', href);
    });
  }

  function finiteNumber(value, fallback) {
    var raw = String(value == null ? '' : value).trim().replace(',', '.');
    if (!raw) return fallback;
    var number = Number(raw);
    return Number.isFinite(number) ? number : fallback;
  }

  function trimmedNumber(value, digits) {
    var number = finiteNumber(value, 0);
    return number.toFixed(digits == null ? 3 : digits).replace(/\.0+$|(?:(\.\d*?)0+)$/, '$1');
  }

  function displayMeters(meters, unit, digits) {
    var value = unit === 'ft' ? finiteNumber(meters, 0) / 0.3048 : finiteNumber(meters, 0);
    return trimmedNumber(value, digits == null ? 3 : digits) + ' ' + (unit === 'ft' ? 'ft' : 'm');
  }

  function getCourtGeometry(courtType) {
    var config = window.SwishCBConfig || {};
    var aliases = { fiba: 'FIBA', nba: 'NBA', ncaa: 'NCAA', usahs: 'US_HIGHSCHOOL' };
    var key = aliases[String(courtType || '').toLowerCase()] || String(courtType || '').toUpperCase();
    var fallbacks = {
      FIBA: { keyW: 4.9, keyL: 5.8, threeR: 6.75 },
      NBA: { keyW: 4.8768, keyL: 5.7912, threeR: 7.239 },
      NCAA: { keyW: 3.6576, keyL: 5.7912, threeR: 6.75 },
      US_HIGHSCHOOL: { keyW: 3.6576, keyL: 5.7912, threeR: 6.0198 }
    };
    return config.OFFICIAL_GEOMETRY && config.OFFICIAL_GEOMETRY[key]
      ? config.OFFICIAL_GEOMETRY[key]
      : (fallbacks[key] || {});
  }

  function getSportAreaColorLabels(courtType) {
    var labels = {
      fiba: { main: 'Main court', key: 'Key' },
      nba: { main: 'Main court', key: 'Key' },
      ncaa: { main: 'Main court', key: 'Key' },
      usahs: { main: 'Main court', key: 'Key' },
      usahs3: { main: 'Main court', key: 'Key' },
      'us-highschool': { main: 'Main court', key: 'Key' },
      'us-highschool3': { main: 'Main court', key: 'Key' },
      'us-high-school': { main: 'Main court', key: 'Key' },
      'high-school': { main: 'Main court', key: 'Key' },
      hs: { main: 'Main court', key: 'Key' },
      basketball: { main: 'Main court', key: 'Key' },
      tennis: { main: 'Backcourt & alleys', key: 'Service courts' },
      pickleball: { main: 'Service courts', key: 'Kitchen' },
      padel: { main: 'Backcourts', key: 'Service boxes' },
      volleyball: { main: 'Back zones', key: 'Front zones' },
      shuffleboard: { main: 'Scoring areas', key: 'Details' },
      cornhole: { main: 'Boards & lanes', key: 'Details' },
      futsal: { main: 'Court halves', key: 'Penalty areas' },
      netball: { main: 'Thirds', key: 'Goal circles' },
      racquetball: { main: 'Racquetball court', key: 'Service zone' }
    };
    return labels[String(courtType || '').trim().toLowerCase()] || {
      main: 'Main court',
      key: 'Secondary court areas'
    };
  }

  function getVisibleBorderSides(params) {
    var sideParameters = {
      left: ['bl', 'bsl'],
      right: ['br', 'bsr'],
      top: ['bt', 'bst'],
      bottom: ['bb', 'bsb']
    };
    return Object.keys(sideParameters).filter(function (side) {
      var keys = sideParameters[side];
      var enabledValue = params.get(keys[0]);
      var size = finiteNumber(params.get(keys[1]), 0);
      var explicitlyEnabled = enabledValue === '1' || enabledValue === 'true';
      var explicitlyDisabled = enabledValue === '0' || enabledValue === 'false';
      return size > 0 && (explicitlyEnabled || !explicitlyDisabled);
    });
  }

  function getColorPresetGroup(card) {
    var item = card && card.closest('.swish-preview-column__item');
    return item && item.querySelector('[data-swish-preview-order-colors]');
  }

  var colorPresetImageBounds = new WeakMap();

  function getColorPresetCourtBounds(source, signature) {
    var cached = colorPresetImageBounds.get(source);
    if (cached && cached.signature === signature) return cached.bounds;
    var width = Number(source.naturalWidth || source.width), height = Number(source.naturalHeight || source.height);
    if (!(width > 0 && height > 0)) return null;
    var canvas = document.createElement('canvas');
    var scale = Math.min(1, 640 / width);
    canvas.width = Math.round(width * scale);
    canvas.height = Math.round(height * scale);
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var left = canvas.width, right = 0, bottom = 0;
    for (var y = 0; y < canvas.height; y++) {
      for (var x = 0; x < canvas.width; x++) {
        var offset = (y * canvas.width + x) * 4;
        if (pixels[offset + 3] > 220 && Math.min(pixels[offset], pixels[offset + 1], pixels[offset + 2]) < 210) {
          left = Math.min(left, x);
          right = Math.max(right, x);
          bottom = Math.max(bottom, y);
        }
      }
    }
    // The court must be fully visible. Avoid deriving a pose from a cropped
    // zoom, an empty canvas, or an all-white surface with only the hoop visible.
    var bounds = left > 1 && right < canvas.width - 2 && bottom < canvas.height - 2 &&
      right - left > canvas.width * 0.4 && bottom > canvas.height * 0.5
      ? { left: left, right: right, bottom: bottom, width: canvas.width, height: canvas.height } : null;
    if (bounds || source.tagName === 'IMG') colorPresetImageBounds.set(source, { signature: signature, bounds: bounds });
    return bounds;
  }

  function getColorPresetFreeThrowAngle(card, tile, yaw, pitch, roll) {
    var api = window.SwishCB;
    var decoded = tile._swishcbDecoded;
    if (!decoded || !getCourtGeometry(decoded.ct).keyL || Math.abs(roll) > 0.001 || !api || !api.previewPlacement || !api.render2D) return null;
    // Only sample the opening pose, never a rotating hover frame. This reads
    // existing imagery; it neither changes nor creates a court renderer.
    var source = tile.querySelector('[data-swishcb-cover]');
    var signature = source && (source.currentSrc || source.src);
    var runtime = tile._swishcbInteractive && tile._swishcbInteractive.runtime || api.previews && api.previews.__runtime;
    var engine = runtime && runtime.engine;
    var view = engine && engine.getViewState();
    if (runtime && runtime.getActiveTile() === tile && view.mode === '3d' && !view.autoRotate &&
      Math.abs(view.yaw - yaw) < 0.001 && Math.abs(view.pitch - pitch) < 0.001) {
      source = engine.canvas;
      signature = (card.dataset.swishPreviewOrderCurrentHash || tile.getAttribute('data-swishcb-hash')) + ':' + source.dataset.swishcbFitDistance;
    }
    if (!source || (source.tagName === 'IMG' && !source.complete)) return null;
    var bounds = getColorPresetCourtBounds(source, signature);
    if (!bounds && source.tagName === 'CANVAS') {
      source = tile.querySelector('[data-swishcb-cover]');
      if (source && source.complete) bounds = getColorPresetCourtBounds(source, source.currentSrc || source.src);
    }
    if (!bounds) return null;
    var unit = decoded.u === 'ft' ? 0.3048 : 1;
    var length = Number(decoded.l) * unit, width = Number(decoded.w) * unit;
    if (!(length > 0 && width > 0)) return null;
    var sy = Math.sin(yaw), cy = Math.cos(yaw), sp = Math.sin(pitch), cp = Math.cos(pitch);
    function cameraPoint(x, z) { return { a: cy * x - sy * z, b: -sp * (sy * x + cy * z), c: cp * (sy * x + cy * z) }; }
    var corners = [[-1, -1], [-1, 1], [1, -1], [1, 1]].map(function (sign) { return cameraPoint(sign[0] * length / 2, sign[1] * width / 2); });
    var left = corners.slice().sort(function (a, b) { return a.a - b.a || b.c - a.c; })[0];
    var right = corners.slice().sort(function (a, b) { return b.a - a.a || b.c - a.c; })[0];
    var near = corners.slice().sort(function (a, b) { return b.c - a.c; })[0];
    var focal = 1 / Math.tan(finiteNumber(tile.getAttribute('data-swishcb-fov'), 38) * Math.PI / 360);
    var aspect = bounds.width / bounds.height;
    var lx = (2 * bounds.left / bounds.width - 1) * aspect / focal;
    var rx = (2 * bounds.right / bounds.width - 1) * aspect / focal;
    var by = (1 - 2 * bounds.bottom / bounds.height) / focal;
    // Recover the perspective camera translation from the rendered footprint.
    // Camera yaw/pitch alone omit the line's depth and the preview's pan/fit.
    var depth = (right.a + rx * right.c - left.a - lx * left.c) / (rx - lx);
    var offsetX = left.a + lx * left.c - lx * depth;
    var offsetY = near.b + by * near.c - by * depth;
    if (!(depth > Math.max.apply(null, corners.map(function (p) { return p.c; })))) return null;
    var rules = api.render2D.resolveRulesetFromCt(decoded.ct);
    var placement = api.previewPlacement.compute({ decoded: decoded, rules: rules, L: length, W: width, ppm: 1, poleBorderM: 0.5, baseOverhangM: Number(rules.geometry.hoopToEnd) || 0 }).placement;
    var baselines = placement.baselinesFromFootprintM, hoops = placement.hoopSelection;
    var keyLength = decoded.kl != null ? Number(decoded.kl) * unit : Number(rules.geometry.keyL);
    var points;
    if (hoops.leftOn) points = [[-length / 2 + baselines.left + keyLength, -1], [-length / 2 + baselines.left + keyLength, 1]];
    else if (hoops.rightOn) points = [[-length / 2 + baselines.right - keyLength, -1], [-length / 2 + baselines.right - keyLength, 1]];
    else if (hoops.topOn) points = [[-1, -width / 2 + baselines.top + keyLength], [1, -width / 2 + baselines.top + keyLength]];
    else if (hoops.bottomOn) points = [[-1, -width / 2 + baselines.bottom - keyLength], [1, -width / 2 + baselines.bottom - keyLength]];
    else return null;
    points = points.map(function (p) { var v = cameraPoint(p[0], p[1]); return { x: (v.a - offsetX) / (depth - v.c), y: -(v.b - offsetY) / (depth - v.c) }; });
    points.sort(function (a, b) { return a.x - b.x; });
    return Math.atan2(points[1].y - points[0].y, points[1].x - points[0].x) * 180 / Math.PI;
  }

  function syncColorPresetAngle(card, group) {
    var item = card.closest('.swish-preview-column__item');
    var tile = item && item.querySelector('[data-swishcb-preview]');
    if (!tile) return;
    var camera = String(tile.getAttribute('data-swishcb-camera') || '').toLowerCase();
    var builderView = camera === 'builder' || camera === 'corner';
    var yawDefault = builderView ? 0.6 : 0;
    var pitchDefault = builderView ? Math.PI / 9 : (camera === 'tiny' ? 1 : 0.82);
    var yaw = finiteNumber(tile.getAttribute('data-swishcb-yaw'),
      finiteNumber(tile.getAttribute('data-swishcb-axis-y'), yawDefault * 180 / Math.PI)) * Math.PI / 180;
    var pitch = finiteNumber(tile.getAttribute('data-swishcb-pitch'),
      finiteNumber(tile.getAttribute('data-swishcb-axis-x'), pitchDefault * 180 / Math.PI));
    pitch = Math.max(3, Math.min(80, pitch)) * Math.PI / 180;
    var roll = finiteNumber(tile.getAttribute('data-swishcb-roll'),
      finiteNumber(tile.getAttribute('data-swishcb-axis-z'), 0));
    // Project the court's cross-court edge through its opening camera angle.
    // Keep the circular buttons flat; only their color divisions turn. Reading
    // the configured pose also keeps swatches steady during hover rotation.
    var edgeAngle = Math.atan2(Math.sin(pitch) * Math.cos(yaw), Math.sin(yaw)) * 180 / Math.PI;
    var gradientAngle = ((180 - edgeAngle + roll) % 360 + 360) % 360;
    try {
      var freeThrowAngle = getColorPresetFreeThrowAngle(card, tile, yaw, pitch, roll);
      if (Number.isFinite(freeThrowAngle)) gradientAngle = 180 + freeThrowAngle;
    } catch (_) { /* Keep the configured angle if an external image cannot be sampled. */ }
    group.style.setProperty('--preset-split-angle', gradientAngle.toFixed(3) + 'deg');
  }

  function initializeTrendingColorPresets(group) {
    if (group.dataset.swishPreviewColorCatalog !== 'trending') return;
    var catalog = window.SwishCBColorCatalog;
    var template = group.parentElement.querySelector('[data-swish-preview-trending-presets]');
    var track = group.querySelector('[data-swish-preview-order-colors-track]');
    var sample = track && track.querySelector('[data-swish-preview-order-color-preset]');
    if (!catalog || !template || !sample) return;
    var fragment = document.createDocumentFragment();
    template.content.querySelectorAll('option').forEach(function (option) {
      var button = sample.cloneNode(true);
      button.dataset.colorPresetId = option.value;
      button.dataset.colorPresetName = option.textContent.trim();
      fragment.appendChild(button);
    });
    track.replaceChildren(fragment);
  }

  function getPresetEdgeColor(card, params, preset) {
    if (getVisibleBorderSides(params).length) return preset.border;
    var summary = card._swishPreviewOrderCanonicalSummary;
    var role = summary && summary.edgeColorSource;
    // The native renderer supplies the painted source for cropped courts.
    // Until it is ready, the main surface is the provisional borderless color.
    return preset[role] || preset.main;
  }

  function syncColorPresets(card) {
    var group = getColorPresetGroup(card);
    if (!group) return;
    syncColorPresetAngle(card, group);
    var params = parseHash(card.dataset.swishPreviewOrderCurrentHash || card.dataset.swishPreviewOrderHash).params;
    var labels = getSportAreaColorLabels(params.get('ct'));
    var lineColor = String(params.get('cl') || '#FFFFFF').trim();
    group.style.setProperty('--preset-line-color', /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(lineColor) ? lineColor : '#FFFFFF');
    var hasBorder = getVisibleBorderSides(params).length > 0;
    group.classList.toggle('has-swish-preview-order-border', hasBorder);
    group.querySelectorAll('[data-swish-preview-order-color-preset]').forEach(function (button) {
      var preset = null;
      if (button.dataset.colorPresetId && window.SwishCBColorCatalog) {
        var courtType = String(params.get('ct') || 'fiba').toLowerCase();
        var ruleset = courtType === 'usahs' ? 'US_HIGHSCHOOL' : courtType.toUpperCase();
        preset = window.SwishCBColorCatalog.resolveColorPreset(button.dataset.colorPresetId, ruleset);
        if (preset) {
          ['main', 'key', 'border', 'lines'].forEach(function (role) {
            button.dataset[role + 'Color'] = preset[role];
            button.dataset[role + 'ColorName'] = preset[role];
            button.style.setProperty('--preset-' + (role === 'lines' ? 'line' : role) + '-color', preset[role]);
          });
          button.dataset.edgeColor = getPresetEdgeColor(card, params, preset);
        }
      }
      var label = labels.key + ': ' + button.dataset.keyColorName + '; ' + labels.main + ': ' + button.dataset.mainColorName;
      if (hasBorder) label += '; Borders: ' + button.dataset.borderColorName;
      if (preset) label = button.dataset.colorPresetName + '. ' + label + '; Lines: ' + preset.lines;
      button.setAttribute('aria-label', label);
      button.title = label;
      button.disabled = false;
      button.setAttribute('aria-pressed', String(
        String(params.get('ck') || '').toUpperCase() === button.dataset.keyColor &&
        String(params.get('cm') || '').toUpperCase() === button.dataset.mainColor &&
        (!hasBorder || String(params.get('cb') || '').toUpperCase() === button.dataset.borderColor) &&
        (!preset || (String(params.get('cl') || '#FFFFFF').toUpperCase() === preset.lines &&
          String(params.get('ce') || '#232221').toUpperCase() === button.dataset.edgeColor))
      ));
    });
  }

  // Serialized into the shared editor. Use the same input/change path as its
  // own color controls, retaining court geometry, artwork and purchase state.
  function applyColorPresetInEditor(preset) {
    if (preset && preset.id) {
      var select = document.querySelector('#color-preset');
      if (!select || !Array.from(select.options).some(function (option) { return option.value === preset.id; })) {
        throw new Error('Trending color preset is not available.');
      }
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
      select.value = preset.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (!preset || !/^#[0-9a-f]{6}$/i.test(preset.main) || !/^#[0-9a-f]{6}$/i.test(preset.key) ||
      (preset.border != null && !/^#[0-9a-f]{6}$/i.test(preset.border))) {
      throw new Error('Invalid court color combination.');
    }
    var main = document.querySelector('#swishcb-color-main');
    var key = document.querySelector('#swishcb-color-key');
    if (!main || !key) throw new Error('Court color controls are not ready.');
    var colors = [[main, preset.main], [key, preset.key]];
    if (preset.border != null) {
      var border = document.querySelector('#swishcb-color-border');
      if (!border) throw new Error('Court border color control is not ready.');
      colors.push([border, preset.border]);
    }
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    colors.forEach(function (pair) {
      pair[0].value = pair[1];
      pair[0].dispatchEvent(new Event('input', { bubbles: true }));
      pair[0].dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (window.SwishCourtBuilder && window.SwishCourtBuilder.useAutomaticEdgeColor) {
      window.SwishCourtBuilder.useAutomaticEdgeColor();
    }
  }

  function initializeColorPresetSlider(group) {
    var track = group.querySelector('[data-swish-preview-order-colors-track]');
    var previous = group.querySelector('[data-swish-preview-order-colors-direction="previous"]');
    var next = group.querySelector('[data-swish-preview-order-colors-direction="next"]');
    if (!track || !previous || !next || group._swishColorSlider) return;
    var buttons = Array.from(track.querySelectorAll('[data-swish-preview-order-color-preset]'));
    function update() {
      var position = Math.abs(track.scrollLeft);
      previous.disabled = position <= 1;
      next.disabled = position >= track.scrollWidth - track.clientWidth - 1;
    }
    function reveal(button) {
      if (!button) return;
      var bounds = track.getBoundingClientRect();
      var item = button.getBoundingClientRect();
      if (item.left < bounds.left + 4) track.scrollBy({ left: item.left - bounds.left - 4 });
      else if (item.right > bounds.right - 4) track.scrollBy({ left: item.right - bounds.right + 4 });
    }
    group.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-swish-preview-order-colors-direction]');
      if (!arrow || !group.contains(arrow)) return;
      var step = buttons.length > 1 ? Math.abs(buttons[1].offsetLeft - buttons[0].offsetLeft) : 52;
      var distance = Math.max(1, Math.floor((track.clientWidth - 8) / step)) * step;
      var direction = arrow === next ? 1 : -1;
      if (getComputedStyle(track).direction === 'rtl') direction *= -1;
      track.scrollBy({ left: direction * distance });
    });
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('focusin', function (event) { reveal(event.target.closest('[data-swish-preview-order-color-preset]')); });
    track.addEventListener('keydown', function (event) {
      var index = buttons.indexOf(event.target);
      if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      var target = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 :
        Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowRight' ? direction : -direction)));
      buttons[target].focus({ preventScroll: true });
    });
    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(function () {
      reveal(track.querySelector('[aria-pressed="true"]'));
      update();
    }) : null;
    if (observer) observer.observe(track);
    group._swishColorSlider = { observer: observer };
    update();
  }

  function initializeColorPresets(card) {
    var group = getColorPresetGroup(card);
    if (!group) return;
    initializeTrendingColorPresets(group);
    syncColorPresets(card);
    initializeColorPresetSlider(group);
    card.closest('.swish-preview-column__item').addEventListener('load', function (event) {
      if (event.target.matches('[data-swishcb-cover], [data-swishcb-snapshot]')) syncColorPresetAngle(card, group);
    }, true);
    group.addEventListener('click', function (event) {
      var button = event.target.closest('[data-swish-preview-order-color-preset]');
      if (!button || !group.contains(button)) return;
      var entry = getCardEntry(card);
      if (!entry) return;
      if (entry.logoEditorActive || entry.logoEditorRequested) exitLogoEditor(entry);
      entry.pendingEditor = '';
      entry.colorPresetSequence = (entry.colorPresetSequence || 0) + 1;
      entry.pendingColorPreset = {
        main: button.dataset.mainColor,
        key: button.dataset.keyColor,
        requestId: entry.colorPresetSequence
      };
      var parsed = parseHash(card.dataset.swishPreviewOrderCurrentHash || card.dataset.swishPreviewOrderHash);
      if (button.dataset.colorPresetId) {
        entry.pendingColorPreset.id = button.dataset.colorPresetId;
        entry.pendingColorPreset.lines = button.dataset.linesColor;
        entry.pendingColorPreset.edge = button.dataset.edgeColor;
        parsed.params.set('cl', entry.pendingColorPreset.lines);
        parsed.params.set('ce', entry.pendingColorPreset.edge);
        parsed.params.set('cea', '1');
        // The native Trending action resets individual color overrides too.
        parsed.params.delete('dc');
      }
      if (button.dataset.colorPresetId || getVisibleBorderSides(parsed.params).length) {
        entry.pendingColorPreset.border = button.dataset.borderColor;
        parsed.params.set('cb', entry.pendingColorPreset.border);
      }
      parsed.params.set('cm', entry.pendingColorPreset.main);
      parsed.params.set('ck', entry.pendingColorPreset.key);
      var hash = parsed.params.toString();
      card.dataset.swishPreviewOrderCurrentHash = hash;
      var canonical = card._swishPreviewOrderCanonicalSummary;
      var labels = getSportAreaColorLabels(parsed.params.get('ct'));
      if (canonical && Array.isArray(canonical.colors)) {
        canonical.colors = canonical.colors.map(function (color) {
          if (entry.pendingColorPreset.lines && (color.targetId === 'lines' || color.label === 'Lines')) return Object.assign({}, color, { value: entry.pendingColorPreset.lines });
          if (entry.pendingColorPreset.edge && (color.targetId === 'edge' || color.label === 'Edges')) return Object.assign({}, color, { value: entry.pendingColorPreset.edge });
          if (color.label === labels.main || color.label === 'Main court area') return Object.assign({}, color, { value: button.dataset.mainColor });
          if (color.label === labels.key) return Object.assign({}, color, { value: button.dataset.keyColor });
          if (entry.pendingColorPreset.border && (color.targetId === 'border' || color.label === 'Border' || color.label === 'Borders')) {
            return Object.assign({}, color, { value: entry.pendingColorPreset.border });
          }
          return color;
        });
      }
      group.setAttribute('aria-busy', 'true');
      group.querySelector('[data-swish-preview-order-colors-status]').textContent = 'Applying ' + button.getAttribute('aria-label') + '.';
      renderStaticSummary(card);
      updateDesignLinks(card, hash);
      refreshPreview(card, hash);
      var navigation = getPreviewNavigation(card);
      if (navigation && navigation.toolbar.hidden) activatePreviewNavigation(card);
      if (sharedEditorActiveEntry === entry && entry.frame && card.classList.contains('is-ready') && card.dataset.swishPreviewOrderLoading !== 'true') {
        entry.frame.contentWindow.postMessage({ type: 'swish-preview-order-color-preset', id: card.dataset.swishPreviewOrderMessageId, preset: entry.pendingColorPreset }, '*');
      } else {
        loadCard(card);
      }
    });
  }

  function syncPreviewHoopRemoval(purchase) {
    if (!purchase) return;
    var panel = purchase.querySelector('[data-swishcb-hoop-purchase-active]');
    if (!panel) return;
    var remove = panel.querySelector('[data-swishcb-hoop-remove]');
    if (purchase.dataset.swishcbHoopPurchaseActive !== 'true') {
      if (remove) remove.remove();
      return;
    }
    if (!remove) {
      remove = purchase.ownerDocument.createElement('button');
      remove.type = 'button';
      remove.className = 'swish-preview-order-card__summary-edit';
      remove.setAttribute('data-swishcb-hoop-remove', '');
      remove.setAttribute('data-swish-preview-order-value-edit', '');
      remove.setAttribute('data-swish-preview-order-editor', 'hoop-remove');
      remove.textContent = 'Remove basketball hoop';
      panel.appendChild(remove);
    }
  }

  function serializeHoopPurchaseUi(scope) {
    var ui = scope && scope.querySelector('[data-swishcb-hoop-purchase]');
    if (!ui) return '';
    var clone = ui.cloneNode(true);
    clone.querySelectorAll('script').forEach(function (node) { node.remove(); });
    var toggle = ui.querySelector('[data-swishcb-hoop-purchase-toggle]');
    var cloneToggle = clone.querySelector('[data-swishcb-hoop-purchase-toggle]');
    if (cloneToggle) cloneToggle.toggleAttribute('checked', !!toggle.checked);
    var select = ui.querySelector('[data-swishcb-hoop-purchase-select]');
    clone.querySelectorAll('[data-swishcb-hoop-purchase-select] option').forEach(function (option) {
      option.toggleAttribute('selected', !!select && option.value === select.value);
    });
    syncPreviewHoopRemoval(clone);
    return clone.outerHTML;
  }

  function syncCardTitle(card, measurements) {
    // Keep the merchant's preset title until a customer edits a total dimension.
    // Use the summary's installed totals (including edges), not the floor hash.
    if (!card._swishPreviewOrderDimensionsEdited) return;
    var item = card.closest('.swish-preview-column__item');
    var heading = item && item.querySelector('.swish-preview-column__card-heading');
    if (!heading) return;
    if (!heading.dataset.swishPreviewOrderOriginalTitle) {
      heading.dataset.swishPreviewOrderOriginalTitle = heading.textContent.trim();
    }
    var original = heading.dataset.swishPreviewOrderOriginalTitle;
    var dimensions = /^\d[\d.,\s]*(?:m|ft)(?:\s+\d[\d.,]*\s+in)?\s+Wide\s*[xÃ—]\s*\d[\d.,\s]*(?:m|ft)(?:\s+\d[\d.,]*\s+in)?\s+Long\b/i;
    if (!dimensions.test(original)) return;
    var width = measurements.find(function (entry) { return entry[2] === 'dimension:width'; });
    var length = measurements.find(function (entry) { return entry[2] === 'dimension:length'; });
    if (!width || !length || !width[1] || !length[1]) return;
    var title = original.replace(dimensions, width[1] + ' Wide x ' + length[1] + ' Long');
    // An edited preset no longer promises official overall dimensions.
    title = title.replace(/\s*\(Official Size\)/gi, '');
    if (heading.textContent !== title) heading.textContent = title;
    var previewLink = item.querySelector('[data-swish-preview-order-preview-link]');
    if (previewLink) {
      previewLink.dataset.swishPreviewOriginalLabel = 'Design ' + title;
      if (previewLink.getAttribute('role') !== 'group') previewLink.setAttribute('aria-label', 'Design ' + title);
    }
    var slot = card.querySelector('[data-swish-preview-order-frame-slot]');
    if (slot) {
      slot.dataset.frameTitle = 'Configure ' + title;
      var frame = slot.querySelector('iframe');
      if (frame) frame.title = slot.dataset.frameTitle;
    }
  }

  function renderStaticSummary(card) {
    var host = card.querySelector('[data-swish-preview-order-summary]');
    if (!host) return;
    var backyardOrder = card.dataset.swishPreviewOrderSummaryMode === 'backyard';
    var simpleOrder = backyardOrder || card.dataset.swishPreviewOrderSummaryMode === 'simple';
    var parsed = parseHash(card.dataset.swishPreviewOrderCurrentHash || card.dataset.swishPreviewOrderHash || '');
    var params = parsed.params;
    var unit = params.get('u') === 'ft' ? 'ft' : 'm';
    var widthValue = finiteNumber(params.get('w'), 0);
    var lengthValue = finiteNumber(params.get('l'), 0);
    var widthM = unit === 'ft' ? widthValue * 0.3048 : widthValue;
    var lengthM = unit === 'ft' ? lengthValue * 0.3048 : lengthValue;
    var geometry = getCourtGeometry(params.get('ct'));
    var dimensionFactor = unit === 'ft' ? 0.3048 : 1;
    var keyWidthM = params.has('kw') ? finiteNumber(params.get('kw'), 0) * dimensionFactor : finiteNumber(geometry.keyW, 0);
    var keyLengthM = params.has('kl') ? finiteNumber(params.get('kl'), 0) * dimensionFactor : finiteNumber(geometry.keyL, 0);
    var threePointM = params.has('tp') ? finiteNumber(params.get('tp'), 0) * dimensionFactor : finiteNumber(geometry.threeR, 0);
    var rawOverhang = params.get('hdl') || params.get('hdr') || params.get('hdt') || params.get('hdb');
    var overhangM = rawOverhang ? finiteNumber(rawOverhang, 0) * (unit === 'ft' ? 0.3048 : 0.01) : 1.1811;
    var hoopMode = Math.max(0, Math.round(finiteNumber(params.get('hm'), 0)));
    if (hoopMode > 0 && !(overhangM > 0)) overhangM = 1.1811;
    var seriesId = String(params.get('ts') || 'elastic').toLowerCase();
    if (seriesId === 'large_elite' || seriesId === 'largeelite' || seriesId === 'large elite') seriesId = 'large-elite';
    var seriesLabels = { elastic: 'Swish Elastic Court', elite: 'Swish Elite Court', 'large-elite': 'Swish Large Elite Court' };
    if (!seriesLabels[seriesId]) seriesId = 'elastic';
    // Resolve installed dimensions and retail totals with the same pure tile
    // and ruleset math as the builder, without creating an editor document.
    var lightweight = window.SwishCBPreviewSummaryMath && window.SwishCBPreviewSummaryMath.resolve(
      parsed.raw, window.Shopify && window.Shopify.country ? window.Shopify.country : '', window.SwishCBConfig
    );
    if (lightweight) {
      widthM = lightweight.footprintWidthM;
      lengthM = lightweight.footprintLengthM;
      widthValue = lightweight.installedWidthM / dimensionFactor;
      lengthValue = lightweight.installedLengthM / dimensionFactor;
      if (lightweight.keyWidthM != null) keyWidthM = lightweight.keyWidthM;
      if (lightweight.keyLengthM != null) keyLengthM = lightweight.keyLengthM;
      if (lightweight.threePointM != null) threePointM = lightweight.threePointM;
      if (lightweight.overhangM != null) overhangM = lightweight.overhangM;
    }
    var edgeSides = String(params.get('he') || 'left,right,bottom,top').split(',').filter(Boolean).length;
    var sportColorLabels = getSportAreaColorLabels(params.get('ct'));
    var visibleBorderSides = getVisibleBorderSides(params);
    var colors = [
      [sportColorLabels.main, params.get('cm') || '#7F7F7F', 'main'],
      [sportColorLabels.key, params.get('ck') || '#121212', 'key']
    ];
    if (visibleBorderSides.length) {
      colors.push([
        visibleBorderSides.length === 1 ? 'Border' : 'Borders',
        params.get('cb') || '#7F7F7F',
        'border'
      ]);
    }
    colors.push(['Lines', params.get('cl') || '#FFFFFF', 'lines']);
    if (edgeSides > 0) colors.push(['Edges', params.get('ce') || '#7F7F7F', 'edge']);
    var measurementItems = [
      ['Total court width', trimmedNumber(widthValue, 3) + ' ' + unit, 'dimension:width'],
      ['Total court length', trimmedNumber(lengthValue, 3) + ' ' + unit, 'dimension:length']
    ];
    if (hoopMode > 0) measurementItems.push(['Hoop overhang', displayMeters(overhangM, unit, 3), 'overhang']);
    if (keyWidthM > 0) measurementItems.push(['Key width', displayMeters(keyWidthM, unit, 3), 'dimension:key-width']);
    if (keyLengthM > 0) measurementItems.push(['Key length', displayMeters(keyLengthM, unit, 3), 'dimension:key-length']);
    if (threePointM > 0 && (!lightweight || lightweight.threePointVisible)) measurementItems.push(['3-point line', displayMeters(threePointM, unit, 3), 'dimension:three-point-line']);

    var canonical = card._swishPreviewOrderCanonicalSummary || null;
    if (canonical && Array.isArray(canonical.measurements) && canonical.measurements.length) {
      var measurementEditors = {
        'Total court width': 'dimension:width',
        'Total court length': 'dimension:length',
        'Hoop overhang': 'overhang',
        'Key width': 'dimension:key-width',
        'Key length': 'dimension:key-length',
        '3-point line': 'dimension:three-point-line'
      };
      measurementItems = canonical.measurements.map(function (entry) {
        return [entry.label, entry.value, measurementEditors[entry.label] || ''];
      });
    }
    if (canonical && Array.isArray(canonical.colors) && canonical.colors.length) {
      colors = canonical.colors.map(function (entry) { return [entry.label, entry.value, entry.targetId]; });
    }
    syncCardTitle(card, measurementItems);

    // Hash dimensions describe the tiled floor. Price the complete installed
    // footprint by adding only the selected edge ramps, once per side.
    var edgeSizeM = { elastic: 0.0725, elite: 0.08, 'large-elite': 0.05 }[seriesId] || 0;
    var edgeMask = params.has('te') ? Math.max(0, Math.min(15, Math.round(finiteNumber(params.get('te'), 15)))) : 15;
    var installedWidthM = widthM + edgeSizeM * (((edgeMask & 4) ? 1 : 0) + ((edgeMask & 8) ? 1 : 0));
    var installedLengthM = lengthM + edgeSizeM * (((edgeMask & 1) ? 1 : 0) + ((edgeMask & 2) ? 1 : 0));
    if (lightweight) {
      installedWidthM = lightweight.installedWidthM;
      installedLengthM = lightweight.installedLengthM;
    }
    var installedAreaM2 = installedWidthM * installedLengthM;
    var pricing = lightweight ? lightweight.pricing : window.SwishCBPricing && typeof window.SwishCBPricing.calculate === 'function'
      ? window.SwishCBPricing.calculate({
          widthM: installedWidthM,
          lengthM: installedLengthM,
          series: seriesId,
          countryCode: window.Shopify && window.Shopify.country ? window.Shopify.country : ''
        })
      : null;
    var price = '';
    if (pricing) {
      price = window.SwishCBPricing.formatTotal(pricing.total, pricing.currencyCode, document.documentElement.lang);
    }
    var hasConfirmedPrice = !!(canonical && canonical.price && !/^Loading/i.test(String(canonical.price)));
    if (hasConfirmedPrice) price = String(canonical.price).replace(/\s+[A-Z]{3}\s*$/, '').trim();
    var submit = card.querySelector('[data-swish-preview-order-submit]');
    var maxCheckoutArea = finiteNumber(card.dataset.swishPreviewOrderMaxAreaM2, 0);
    // Native state is authoritative after tile snapping or customer edits.
    if (canonical && Number.isFinite(canonical.installedAreaM2) && canonical.installedAreaM2 > 0) installedAreaM2 = canonical.installedAreaM2;
    card.dataset.swishPreviewOrderInstalledAreaM2 = String(installedAreaM2);
    var requiresCustomQuote = maxCheckoutArea > 0 && installedAreaM2 >= maxCheckoutArea;
    card.dataset.swishPreviewOrderCustomQuote = requiresCustomQuote ? 'true' : 'false';
    if (submit) {
      if (!submit.dataset.swishPreviewOrderLabel) {
        submit.dataset.swishPreviewOrderLabel = String(submit.textContent || 'Order Now').trim();
      }
      submit.textContent = requiresCustomQuote
        ? 'Contact Us'
        : (card.dataset.swishPreviewOrderCheckoutLoading === 'true' ? 'Loading...' : submit.dataset.swishPreviewOrderLabel);
      if (requiresCustomQuote) {
        card.dataset.swishPreviewOrderCheckoutLoading = 'false';
        submit.disabled = false;
        submit.setAttribute('aria-busy', 'false');
        submit.title = 'Contact us for courts of ' + trimmedNumber(maxCheckoutArea, 0) + ' mÂ² or more.';
        submit.setAttribute('data-contact-popup-trigger', 'contact-popup');
        submit.setAttribute('aria-haspopup', 'dialog');
        card.dataset.swishPreviewOrderPendingSubmit = 'false';
        submit.classList.remove('loading');
      } else {
        submit.removeAttribute('title');
        submit.removeAttribute('data-contact-popup-trigger');
        submit.removeAttribute('aria-haspopup');
      }
    }

    var editButton = function (value, label, editor) {
      return '<button type="button" class="swish-preview-order-card__summary-edit" data-swish-preview-order-value-edit' +
        (editor ? ' data-swish-preview-order-editor="' + escapeAttribute(editor) + '"' : '') +
        ' aria-label="Edit ' + escapeAttribute(label) + '">' + escapeAttribute(value) + '</button>';
    };
    var editIcon = function (label, editor) {
      return '<button type="button" class="swish-preview-order-card__summary-pencil"' +
        ' data-swish-preview-order-value-edit data-swish-preview-order-editor="' + escapeAttribute(editor) + '"' +
        ' aria-label="Edit ' + escapeAttribute(label) + '" aria-haspopup="dialog"></button>';
    };
    if (simpleOrder) {
      var simpleLabels = {
        'dimension:width': 'Total court width',
        'dimension:length': 'Total court length',
        overhang: 'Hoop overhang'
      };
      if (backyardOrder) {
        simpleLabels['dimension:key-width'] = 'Key width';
        simpleLabels['dimension:key-length'] = 'Key length';
        simpleLabels['dimension:three-point-line'] = '3-point line';
      }
      measurementItems = measurementItems.filter(function (entry) { return !!simpleLabels[entry[2]]; })
        .map(function (entry) { return [simpleLabels[entry[2]], entry[1], entry[2]]; });
    }
    if (backyardOrder) {
      var backyardOrderKeys = ['dimension:width', 'dimension:length', 'dimension:key-width', 'dimension:key-length', 'dimension:three-point-line', 'overhang'];
      measurementItems.sort(function (a, b) { return backyardOrderKeys.indexOf(a[2]) - backyardOrderKeys.indexOf(b[2]); });
    }
    var measurementList = '<ul class="swish-preview-order-card__summary-list">' + measurementItems.map(function (entry) {
      var help = backyardOrder && entry[2] === 'overhang';
      return '<li' + (help ? ' class="swish-preview-overhang-row"' : '') +
        (entry[2] === 'dimension:three-point-line' ? ' data-swish-preview-order-detail="three-point"' : '') + '>' + escapeAttribute(entry[0]) + ': ' + (help ? '<span class="swish-preview-overhang-value">' : '') +
        editButton(entry[1], entry[0], entry[2]) + (help ? ' ' + overhangHelpMarkup() : '') +
        editIcon(entry[0], entry[2]) + (help ? '</span>' : '') + '</li>';
    }).join('') + (backyardOrder ? '' : '<li data-swish-preview-order-series>Tile series: ' + editButton(seriesLabels[seriesId], 'Tile series', 'series') +
      editIcon('Tile series', 'series') + '</li>') + '</ul>';
    var colorList = '<ul class="swish-preview-order-card__summary-list">' + colors.map(function (entry) {
      var color = /^#[0-9a-f]{6}$/i.test(entry[1]) ? entry[1].toUpperCase() : '#000000';
      var colorTargets = {
        'Main court': 'main',
        'Main court area': 'main',
        'Backcourt & alleys': 'main',
        'Service courts': entry[0] === sportColorLabels.main ? 'main' : 'key',
        Backcourts: 'main',
        'Back zones': 'main',
        'Scoring areas': 'main',
        'Boards & lanes': 'main',
        'Court halves': 'main',
        Thirds: 'main',
        'Racquetball court': 'main',
        Key: 'key',
        Kitchen: 'key',
        'Service boxes': 'key',
        'Front zones': 'key',
        Details: 'key',
        'Penalty areas': 'key',
        'Goal circles': 'key',
        'Service zone': 'key',
        Border: 'border',
        Borders: 'border',
        Lines: 'lines',
        'Court lines': 'lines',
        Edges: 'edge'
      };
      var editor = 'color:' + (entry[2] || colorTargets[entry[0]] || 'main');
      return '<li><span class="swish-preview-order-card__summary-color">' + escapeAttribute(entry[0]) + ': ' +
        editButton(color, entry[0] + ' color', editor) +
        '<button type="button" class="swish-preview-order-card__summary-swatch" style="background:' + color + '"' +
          ' data-swish-preview-order-value-edit data-swish-preview-order-editor="' + editor + '"' +
          ' aria-label="Edit ' + escapeAttribute(entry[0]) + ' color, currently ' + color + '"></button>' +
        editIcon(entry[0] + ' color', editor) +
        '</span></li>';
    }).join('') + '</ul>';
    var canonicalLogo = canonical && canonical.logo ? canonical.logo : null;
    var logoState = canonicalLogo && canonicalLogo.state ? canonicalLogo.state : (params.get('lu') ? 'Uploaded' : 'None');
    var logoAction = canonicalLogo && canonicalLogo.action ? canonicalLogo.action : (params.get('lu') ? 'Change' : 'Upload');
    var logoInputId = 'swish-preview-order-logo-' + String(card.dataset.swishPreviewOrderMessageId || '')
      .replace(/[^a-z0-9_-]+/gi, '-');
    var logoEditControl = '<button type="button" class="swish-preview-order-card__summary-edit"' +
      ' data-swish-preview-order-value-edit data-swish-preview-order-editor="logo"' +
      ' aria-controls="' + escapeAttribute(logoInputId) + '" aria-label="Edit logos">' + escapeAttribute(logoAction) +
      '</button><input id="' + escapeAttribute(logoInputId) + '" type="file" accept="image/*"' +
      ' data-swish-preview-order-logo-file hidden>';
    var canonicalHoop = canonical && canonical.hoop ? canonical.hoop : null;
    // Use the main builder's server-gated component, including its live model
    // options and price rows. Do not maintain another region list or catalog.
    var hoopMarkup = hoopMode > 0
      ? String(canonicalHoop && canonicalHoop.markup || card._swishPreviewHoopMarkup || '')
      : '';

    host.innerHTML =
      '<div class="swish-preview-order-card__summary-group">' +
      (simpleOrder ? '<h4 class="swish-preview-order-card__summary-heading">Court Details</h4>' :
        '<h4 class="swish-preview-order-card__summary-heading">Measurements</h4>') + measurementList + '</div>' +
      (simpleOrder ? '' :
      '<div class="swish-preview-order-card__summary-group" data-swish-preview-order-detail="colors"><h4 class="swish-preview-order-card__summary-heading">Colors</h4>' + colorList + '</div>' +
      '<div class="swish-preview-order-card__summary-group" data-swish-preview-order-detail="logos"><h4 class="swish-preview-order-card__summary-heading">Logos</h4>' +
        '<ul class="swish-preview-order-card__summary-list"><li>Logos: ' + escapeAttribute(logoState) + ' ' +
        logoEditControl + '</li></ul></div>') +
      '<div class="swish-preview-order-card__summary-pricing">' +
      (price ? '<p class="swish-preview-order-card__summary-price price">' + escapeAttribute(price) + '</p>' : '') +
      '<p class="swish-preview-order-card__summary-shipping">Free shipping on tiles</p>' +
      hoopMarkup + '</div>';
    scheduleLogoEditorPosition();
    syncColorPresets(card);
    applyPreviewSummaryPresentation(host, getCardSummaryPresentation(card), false);
  }

  function getCardSummaryPresentation(card) {
    if (card._swishPreviewSummaryPresentation) return card._swishPreviewSummaryPresentation;
    var summary = card.querySelector('[data-swish-preview-order-summary]');
    var groups = Array.from(summary.querySelectorAll('.swish-preview-order-card__summary-group'));
    card._swishPreviewSummaryPresentation = groups.filter(function (group) {
      return window.getComputedStyle(group).display !== 'none';
    }).map(function (group) {
      return {
        detail: group.dataset.swishPreviewOrderDetail || 'measurements',
        heading: group.querySelector('.swish-preview-order-card__summary-heading').textContent.trim(),
        rows: Array.from(group.querySelectorAll('li')).filter(function (row) {
          return window.getComputedStyle(row).display !== 'none';
        }).map(function (row) {
          var editor = row.querySelector('[data-swish-preview-order-editor]');
          return {
            editor: editor ? editor.dataset.swishPreviewOrderEditor : '',
            label: row.textContent.split(':')[0].trim(),
            official: !!row.querySelector('[data-swishcb-product-dimension-reset]')
          };
        })
      };
    });
    return card._swishPreviewSummaryPresentation;
  }

  // The initially displayed options are the contract for this card. Reuse it
  // for both the lightweight summary and the shared native editor, even when
  // geometry changes cause the builder to generate extra specification rows.
  function applyPreviewSummaryPresentation(summary, presentation, native) {
    if (!summary || !Array.isArray(presentation)) return;
    var selector = native ? '.swishcb__order-specification' : '.swish-preview-order-card__summary-group';
    Array.from(summary.querySelectorAll(selector)).forEach(function (group) {
      var heading = group.querySelector(native ? '.swishcb__order-specification-heading' : '.swish-preview-order-card__summary-heading');
      if (!heading) return;
      var original = group.dataset.swishPreviewOrderOriginalHeading || heading.textContent.trim();
      var detail = group.dataset.swishPreviewOrderDetail || (original === 'Measurements' || original === 'Court Details' ? 'measurements' : '');
      var configured = presentation.find(function (entry) { return entry.detail === detail; });
      group.toggleAttribute('data-swish-preview-simple-hidden', !configured);
      if (!configured) return;
      if (heading.textContent !== configured.heading) heading.textContent = configured.heading;
      var list = group.querySelector('ul');
      if (!list) return;
      var rows = Array.from(list.children);
      var usedOptions = [];
      rows.forEach(function (row) {
        var editor = row.querySelector('[data-swish-preview-order-editor]');
        var key = editor ? editor.dataset.swishPreviewOrderEditor : '';
        if (native) {
          var dimension = row.querySelector('[data-swishcb-product-dimension-input]');
          var color = row.querySelector('[data-swishcb-order-color-swatch]');
          if (dimension) key = 'dimension:' + dimension.dataset.swishcbDimensionKind;
          else if (row.querySelector('[data-swishcb-product-overhang-input]')) key = 'overhang';
          else if (row.hasAttribute('data-swish-preview-order-series')) key = 'series';
          else if (color) key = 'color:' + color.dataset.swishcbOrderColorTargetId;
          else if (row.querySelector('[data-swish-preview-order-logo-picker]')) key = 'logo';
        }
        var option = configured.rows.find(function (entry) {
          return entry.editor === key && key && usedOptions.indexOf(entry) < 0;
        });
        row.toggleAttribute('data-swish-preview-simple-hidden', !option);
        if (!option) return;
        usedOptions.push(option);
        row.dataset.swishPreviewOrderOptionIndex = String(configured.rows.indexOf(option));
        row.querySelectorAll('[data-swishcb-product-dimension-reset]').forEach(function (button) {
          button.toggleAttribute('data-swish-preview-simple-hidden', !option.official);
        });
        var colorText = row.querySelector('.swishcb__order-color-text, .swish-preview-order-card__summary-color');
        var label = colorText ? colorText.firstChild : row.firstChild;
        var text = option.label + ': ';
        if (label && label.nodeType === 3 && label.nodeValue !== text) label.nodeValue = text;
      });
      var ordered = rows.slice().sort(function (a, b) {
        var aIndex = a.hasAttribute('data-swish-preview-simple-hidden') ? configured.rows.length : Number(a.dataset.swishPreviewOrderOptionIndex);
        var bIndex = b.hasAttribute('data-swish-preview-simple-hidden') ? configured.rows.length : Number(b.dataset.swishPreviewOrderOptionIndex);
        return aIndex - bIndex;
      });
      if (rows.some(function (row, index) { return row !== ordered[index]; })) ordered.forEach(function (row) { list.appendChild(row); });
    });
  }

  function setBuilderRootAttributes(html, preset, designUrl, contextId) {
    var unit = parseHash(preset).params.get('u') === 'ft' ? 'ft' : 'm';
    var sourceUrl = '';
    try { sourceUrl = new URL(String(designUrl || ''), window.location.href).href; } catch (_) {}
    return String(html || '').replace(
      /<div\s+[^>]*id="swish-court-builder"[^>]*>/,
      function (tag) {
        // The embedded editor keeps its compact layout when it reuses full-builder markup.
        var next = tag.replace(/\sdata-swishcb-configurator="[^"]*"/, '')
          .replace(/>$/, ' data-swish-preview-order-context="' + escapeAttribute(String(contextId || '')) + '">');
        var presetAttribute = 'data-default-share-hash="' + escapeAttribute(setEngineHash(preset)) + '"';
        var shareAttribute = 'data-share-base-url="' + escapeAttribute(String(designUrl || '').split('#')[0]) + '"';
        var unitsAttribute = 'data-default-units="' + unit + '"';
        var sourceAttribute = 'data-swishcb-order-source-url="' + escapeAttribute(sourceUrl) + '"';
        var runtimeModeAttribute = 'data-swishcb-runtime-mode="order-editor"';

        if (/data-default-share-hash="[^"]*"/.test(next)) {
          next = next.replace(/data-default-share-hash="[^"]*"/, presetAttribute);
        } else {
          next = next.replace(/>$/, ' ' + presetAttribute + '>');
        }

        if (/data-share-base-url="[^"]*"/.test(next)) {
          next = next.replace(/data-share-base-url="[^"]*"/, shareAttribute);
        } else {
          next = next.replace(/>$/, ' ' + shareAttribute + '>');
        }

        if (/data-default-units="[^"]*"/.test(next)) {
          next = next.replace(/data-default-units="[^"]*"/, unitsAttribute);
        } else {
          next = next.replace(/>$/, ' ' + unitsAttribute + '>');
        }

        if (/data-swishcb-order-source-url="[^"]*"/.test(next)) {
          next = next.replace(/data-swishcb-order-source-url="[^"]*"/, sourceAttribute);
        } else {
          next = next.replace(/>$/, ' ' + sourceAttribute + '>');
        }

        if (/data-swishcb-runtime-mode="[^"]*"/.test(next)) {
          next = next.replace(/data-swishcb-runtime-mode="[^"]*"/, runtimeModeAttribute);
        } else {
          next = next.replace(/>$/, ' ' + runtimeModeAttribute + '>');
        }

        if (/class="[^"]*"/.test(next)) {
          next = next.replace(/class="([^"]*)"/, function (_, classes) {
            return 'class="' + classes + ' swishcb--preview-order-card swishcb--no-sticky"';
          });
        } else {
          next = next.replace(/>$/, ' class="swishcb swishcb--preview-order-card swishcb--no-sticky">');
        }
        return next;
      }
    );
  }

  // Presentation only: preserve native inputs, validation and the full share state.
  // The shared editor can switch between Full and Simple cards without data loss.
  function syncOrderSummaryPresentation(mode, presentation) {
    var backyard = mode === 'backyard';
    var simple = backyard || mode === 'simple';
    var labels = {
      'Total court width': 'Total court width',
      'Total court length': 'Total court length',
      'Hoop overhang': 'Hoop overhang'
    };
    if (backyard) {
      labels['Key width'] = 'Key width';
      labels['Key length'] = 'Key length';
      labels['3-point line'] = '3-point line';
    }
    // Match the compact resting card, including its initial logo upload action.
    // The native order summary only creates its Logos group after an upload.
    var specifications = document.querySelector('.swishcb__product-order-specifications');
    if (specifications) {
      var logoGroup = specifications.querySelector('[data-swish-preview-order-logo-group]');
      if (!logoGroup) {
        logoGroup = document.createElement('div');
        logoGroup.className = 'swishcb__order-specification';
        logoGroup.setAttribute('data-swish-preview-order-logo-group', '');
        logoGroup.innerHTML = '<h4 class="swishcb__order-specification-heading">Logos</h4>' +
          '<ul class="swishcb__order-specification-values"><li>Logos: ' +
          '<span data-swish-preview-order-logo-state>None</span> ' +
          '<button type="button" data-swish-preview-order-logo-picker aria-label="Edit logos">Upload</button></li></ul>';
        specifications.appendChild(logoGroup);
        logoGroup.querySelector('[data-swish-preview-order-logo-picker]').addEventListener('click', function () {
          post({ type: 'swish-preview-order-logo-picker' });
        });
      }
      if (specifications.lastElementChild !== logoGroup) specifications.appendChild(logoGroup);
      var logoApi = window.SwishCourtBuilder;
      var hasLogos = !!(logoApi && typeof logoApi.getPreviewLogos === 'function' && logoApi.getPreviewLogos().length);
      var logoState = logoGroup.querySelector('[data-swish-preview-order-logo-state]');
      var logoPicker = logoGroup.querySelector('[data-swish-preview-order-logo-picker]');
      var stateText = hasLogos ? 'Uploaded' : 'None';
      var actionText = hasLogos ? 'Change' : 'Upload';
      if (logoState.textContent !== stateText) logoState.textContent = stateText;
      if (logoPicker.textContent !== actionText) logoPicker.textContent = actionText;
    }
    document.querySelectorAll('.swishcb__product-order-specifications .swishcb__order-specification').forEach(function (group) {
      var heading = group.querySelector('.swishcb__order-specification-heading');
      if (!heading) return;
      var original = group.dataset.swishPreviewOrderOriginalHeading || heading.textContent.trim();
      group.dataset.swishPreviewOrderOriginalHeading = original;
      if (original === 'Logos') group.setAttribute('data-swish-preview-order-detail', 'logos');
      if (original === 'Additional sports') group.setAttribute('data-swish-preview-order-detail', 'additional-sports');
      if (original === 'Colors') group.setAttribute('data-swish-preview-order-detail', 'colors');
      group.toggleAttribute('data-swish-preview-native-logo-hidden', original === 'Logos' && !group.hasAttribute('data-swish-preview-order-logo-group'));
      group.toggleAttribute('data-swish-preview-simple-hidden', simple && original !== 'Measurements');
      if (original !== 'Measurements') return;
      var headingText = simple ? 'Court Details' : original;
      if (!presentation && heading.textContent !== headingText) heading.textContent = headingText;
      heading.toggleAttribute('data-swish-preview-simple-heading', simple);
      group.querySelectorAll('.swishcb__order-specification-values>li').forEach(function (row) {
        if (row.hasAttribute('data-swish-preview-order-series')) return;
        var text = row.firstChild;
        if (!text || text.nodeType !== 3) return;
        var label = row.dataset.swishPreviewOrderOriginalLabel || text.nodeValue.replace(/:\s*$/, '').trim();
        row.dataset.swishPreviewOrderOriginalLabel = label;
        if (label === '3-point line') row.setAttribute('data-swish-preview-order-detail', 'three-point');
        var showHelp = backyard && label === 'Hoop overhang';
        if (row.classList.contains('swish-preview-overhang-row') !== showHelp) row.classList.toggle('swish-preview-overhang-row', showHelp);
        var labelText = (simple && labels[label] ? labels[label] : label) + ': ';
        if (!presentation && text.nodeValue !== labelText) text.nodeValue = labelText;
        var hint = row.querySelector('[data-swish-preview-overhang-hint]');
        if (showHelp && !hint) {
          hint = document.createElement('span');
          hint.setAttribute('data-swish-preview-overhang-hint', '');
          hint.innerHTML = ' ' + overhangHelpMarkup();
          row.appendChild(hint);
        } else if (!showHelp && hint) hint.remove();
        var valueGroup = row.querySelector('.swish-preview-overhang-value');
        var overhangEditor = row.querySelector('.swishcb__product-order-overhang-editor');
        if (showHelp && overhangEditor && !valueGroup) {
          valueGroup = document.createElement('span');
          valueGroup.className = 'swish-preview-overhang-value';
          row.insertBefore(valueGroup, overhangEditor);
          valueGroup.appendChild(overhangEditor);
          valueGroup.appendChild(hint);
        } else if (!showHelp && valueGroup) valueGroup.replaceWith.apply(valueGroup, Array.from(valueGroup.childNodes));
        row.toggleAttribute('data-swish-preview-simple-hidden', simple && !labels[label]);
      });
      var list = group.querySelector('.swishcb__order-specification-values');
      if (!list) return;
      if (backyard) {
        var oldSeriesRow = list.querySelector('[data-swish-preview-order-series]');
        if (oldSeriesRow) oldSeriesRow.remove();
        var order = ['Total court width', 'Total court length', 'Key width', 'Key length', '3-point line', 'Hoop overhang'];
        var rows = Array.from(list.children);
        var sorted = rows.slice().sort(function (a, b) { return order.indexOf(a.dataset.swishPreviewOrderOriginalLabel) - order.indexOf(b.dataset.swishPreviewOrderOriginalLabel); });
        if (!presentation && rows.some(function (row, index) { return row !== sorted[index]; })) sorted.forEach(function (row) { list.appendChild(row); });
        return;
      }
      var seriesSelect = document.querySelector('#swishcb-tile-series');
      var series = String(seriesSelect && seriesSelect.value || 'elastic').trim().toLowerCase();
      var seriesLabel = series === 'elite' ? 'Swish Elite Court' :
        (['large-elite', 'large_elite', 'largeelite', 'large elite'].indexOf(series) >= 0 ? 'Swish Large Elite Court' : 'Swish Elastic Court');
      var seriesRow = list.querySelector('[data-swish-preview-order-series]');
      if (!seriesRow) {
        seriesRow = document.createElement('li');
        seriesRow.setAttribute('data-swish-preview-order-series', '');
        seriesRow.appendChild(document.createTextNode('Tile series: '));
        var valueButton = document.createElement('button');
        valueButton.type = 'button';
        valueButton.className = 'swishcb__preview-series-value';
        valueButton.setAttribute('data-swish-preview-series-trigger', '');
        valueButton.setAttribute('aria-label', 'Change tile series');
        valueButton.setAttribute('aria-haspopup', 'dialog');
        valueButton.setAttribute('aria-expanded', 'false');
        seriesRow.appendChild(valueButton);
        var editButton = valueButton.cloneNode();
        editButton.className = 'swishcb__order-edit';
        editButton.textContent = 'Edit';
        seriesRow.appendChild(editButton);
        list.appendChild(seriesRow);
      }
      var value = seriesRow.querySelector('.swishcb__preview-series-value');
      if (value.textContent !== seriesLabel) value.textContent = seriesLabel;
    });
    applyPreviewSummaryPresentation(specifications, presentation, true);
  }

  // Native edits replace the summary nodes. Restore the card's configured
  // presentation in the same render cycle, before hidden options can be painted.
  // Observe only this summary, and keep presentation writes idempotent so they
  // do not create a mutation loop or interfere with the active measurement panel.
  function bindPreviewSummaryPresentation(syncPresentation) {
    var specifications = document.querySelector('[data-swishcb-product-order-specifications]');
    if (!specifications || !window.MutationObserver) return;
    var observer = new MutationObserver(function () { syncPresentation(); });
    observer.observe(specifications, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pagehide', function () { observer.disconnect(); }, { once: true });
  }

  // Runs inside the shared editor. Apply selections through the builder's own
  // change handler so tile fitting, pricing, borders and order data stay together.
  function bindPreviewTileSeriesPicker() {
    var panel = null, trigger = null;
    var labels = { elastic: 'Swish Elastic Court', elite: 'Swish Elite Court', 'large-elite': 'Swish Large Elite Court' };
    var style = document.createElement('style');
    style.textContent = '.swishcb__preview-series-value{appearance:none;background:transparent;border:0;border-bottom:var(--swishcb-order-inline-underline-width,.15rem) dotted var(--swishcb-order-inline-underline-color,currentColor);border-radius:0;color:rgb(var(--color-foreground));font:inherit;line-height:1.3;padding:0;margin:0;cursor:pointer}' +
      '.swishcb__preview-series-value:focus-visible{outline:2px solid currentColor;outline-offset:3px}' +
      '.swishcb__series-popover{position:fixed;width:288px;min-width:0;max-width:calc(100vw - 24px);max-height:calc(100dvh - 24px);overflow:auto}' +
      '.swishcb__series-options{display:grid;gap:8px}' +
      '.swishcb__series-options button{min-height:44px;width:100%;padding:10px 12px;border:1px solid #cbd5e1;border-radius:8px;background:#fff;color:#111827;font:inherit;text-align:left;cursor:pointer}' +
      '.swishcb__series-options button[aria-pressed="true"]{background:#111827;color:#fff;border-color:#111827}' +
      '.swishcb__series-options button:focus-visible{outline:2px solid #111827;outline-offset:2px}' +
      '.swishcb__series-options button:disabled{opacity:.45;cursor:not-allowed}';
    document.head.appendChild(style);

    function source() {
      return document.querySelector('#swish-court-builder [data-swishcb-product-series-select]') ||
        document.querySelector('#swishcb-tile-series');
    }
    function close(restoreFocus) {
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      document.querySelectorAll('[data-swish-preview-series-trigger]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      if (restoreFocus) {
        var current = trigger && trigger.isConnected ? trigger : document.querySelector('.swishcb__preview-series-value');
        if (current) current.focus({ preventScroll: true });
      }
    }
    function position() {
      if (!panel || panel.hidden) return;
      var anchor = trigger && trigger.isConnected ? trigger : document.querySelector('.swishcb__preview-series-value');
      if (!anchor) return close(false);
      var bounds = anchor.getBoundingClientRect();
      panel.style.left = Math.max(12, Math.min(bounds.left, innerWidth - panel.offsetWidth - 12)) + 'px';
      panel.style.top = Math.max(12, Math.min(bounds.bottom + 8, innerHeight - panel.offsetHeight - 12)) + 'px';
    }
    function open(button) {
      var select = source();
      trigger = button || document.querySelector('.swishcb__preview-series-value');
      if (!select || !trigger) return false;
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'swishcb__color-popover swishcb__series-popover';
        panel.id = 'swish-preview-tile-series-panel';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'false');
        panel.setAttribute('aria-labelledby', panel.id + '-title');
        panel.innerHTML = '<div class="swishcb__color-popover__title" id="' + panel.id + '-title">Tile series</div>' +
          '<button type="button" class="swishcb__color-popover__close-x" data-series-close aria-label="Close tile series">Ã—</button>' +
          '<div class="swishcb__series-options" role="group" aria-label="Tile series options"></div>';
        document.body.appendChild(panel);
        panel.querySelector('[data-series-close]').addEventListener('click', function () { close(true); });
        panel.addEventListener('click', function (event) {
          var option = event.target.closest('[data-preview-series-option]');
          if (!option || option.disabled) return;
          var target = source(), next = option.dataset.previewSeriesOption;
          close(true);
          if (!target || target.value === next) return;
          target.value = next;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      var group = panel.querySelector('.swishcb__series-options');
      group.textContent = '';
      var root = document.querySelector('#swish-court-builder');
      Object.keys(labels).forEach(function (id) {
        var nativeOption = select.querySelector('option[value="' + id + '"]');
        var option = document.createElement('button');
        option.type = 'button';
        option.dataset.previewSeriesOption = id;
        option.textContent = labels[id];
        option.disabled = !nativeOption || nativeOption.disabled || (root.dataset.swishcbPickleballSeriesRestricted === 'true' && id !== 'elastic');
        option.setAttribute('aria-pressed', String(select.value === id));
        group.appendChild(option);
      });
      panel.hidden = false;
      document.querySelectorAll('[data-swish-preview-series-trigger]').forEach(function (button) {
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('aria-expanded', 'true');
      });
      position();
      document.dispatchEvent(new CustomEvent('swishcb:popover-open', { detail: { element: panel } }));
      var selected = group.querySelector('[aria-pressed="true"]:not(:disabled)') || group.querySelector('button:not(:disabled)');
      if (selected) selected.focus({ preventScroll: true });
      return true;
    }
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-swish-preview-series-trigger]');
      if (button) { event.preventDefault(); open(button); }
    });
    document.addEventListener('pointerdown', function (event) {
      if (panel && !panel.contains(event.target) && !event.target.closest('[data-swish-preview-series-trigger]')) close(false);
    });
    document.addEventListener('focusin', function (event) {
      if (panel && !panel.contains(event.target) && !event.target.closest('[data-swish-preview-series-trigger]')) close(false);
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(true); });
    document.addEventListener('swishcb:popover-open', function (event) {
      if (!event.detail || event.detail.element !== panel) close(false);
    });
    window.addEventListener('resize', position);
    return { open: open };
  }

  // The embedded summary has its own viewport. Keep its editors visible in
  // the storefront viewport too, and bridge dismissal across the iframe.
  function bindPreviewPopoverViewport() {
    var host = window.parent, frame = window.frameElement;
    if (!frame || host === window) return;
    var activePanel = null, pendingFrame = 0, expectedScrollY = null;
    var observer = window.ResizeObserver ? new ResizeObserver(scheduleFit) : null;

    function dismiss() {
      if (!activePanel || activePanel.hidden) return;
      activePanel = null;
      if (observer) observer.disconnect();
      document.dispatchEvent(new CustomEvent('swishcb:popover-open', { detail: { element: null } }));
    }
    function fit() {
      pendingFrame = 0;
      if (!activePanel || activePanel.hidden || !frame.isConnected) return;
      var panelRect = activePanel.getBoundingClientRect(), frameRect = frame.getBoundingClientRect();
      var viewport = host.visualViewport;
      var top = (viewport ? viewport.offsetTop : 0) + 12;
      var bottom = (viewport ? viewport.offsetTop + viewport.height : host.innerHeight) - 12;
      var panelTop = frameRect.top + panelRect.top, panelBottom = frameRect.top + panelRect.bottom;
      var delta = panelBottom > bottom ? panelBottom - bottom : panelTop < top ? panelTop - top : 0;
      // Do not oscillate if an on-screen keyboard leaves less room than the
      // complete editor. Its normal viewport overflow remains the fallback.
      if (panelRect.height > bottom - top || Math.abs(delta) < 1) return;
      var previousY = host.scrollY;
      host.scrollBy({ top: delta, behavior: 'instant' });
      expectedScrollY = host.scrollY !== previousY ? host.scrollY : null;
    }
    function scheduleFit() {
      if (!pendingFrame) pendingFrame = requestAnimationFrame(fit);
    }
    function outside(event) {
      if (event.target !== frame) dismiss();
    }
    function scroll(event) {
      if (event.target === host.document && expectedScrollY !== null && Math.abs(host.scrollY - expectedScrollY) < 1) {
        expectedScrollY = null;
        return;
      }
      expectedScrollY = null;
      dismiss();
    }
    function otherPopover(event) {
      if (!event.detail || event.detail.element !== frame) dismiss();
    }
    function escape(event) {
      if (event.key === 'Escape') dismiss();
    }
    document.addEventListener('swishcb:popover-open', function (event) {
      var panel = event.detail && event.detail.element;
      if (!panel || !panel.matches('.swishcb__color-popover')) return;
      activePanel = panel;
      if (observer) { observer.disconnect(); observer.observe(panel); }
      host.document.dispatchEvent(new host.CustomEvent('swishcb:popover-open', { detail: { element: frame } }));
      scheduleFit();
    });
    host.document.addEventListener('pointerdown', outside, true);
    host.document.addEventListener('focusin', outside, true);
    host.document.addEventListener('scroll', scroll, { capture: true, passive: true });
    host.document.addEventListener('keydown', escape);
    host.document.addEventListener('swishcb:popover-open', otherPopover);
    host.addEventListener('resize', scheduleFit);
    if (host.visualViewport) host.visualViewport.addEventListener('resize', scheduleFit);
    window.addEventListener('pagehide', function () {
      if (observer) observer.disconnect();
      if (pendingFrame) cancelAnimationFrame(pendingFrame);
      host.document.removeEventListener('pointerdown', outside, true);
      host.document.removeEventListener('focusin', outside, true);
      host.document.removeEventListener('scroll', scroll, true);
      host.document.removeEventListener('keydown', escape);
      host.document.removeEventListener('swishcb:popover-open', otherPopover);
      host.removeEventListener('resize', scheduleFit);
      if (host.visualViewport) host.visualViewport.removeEventListener('resize', scheduleFit);
    });
  }

  function childBootstrapMarkup(card, initialMessageId) {
    var summaryMode = JSON.stringify(card.dataset.swishPreviewOrderSummaryMode || 'full');
    var summaryPresentation = JSON.stringify(getCardSummaryPresentation(card));
    var messageId = JSON.stringify(String(initialMessageId || card.dataset.swishPreviewOrderMessageId || ''));
    var parentOrigin = JSON.stringify(window.location.origin);
    var designUrl = JSON.stringify(String(card.dataset.swishPreviewOrderDesignUrl || ''));
    var fallbackHash = JSON.stringify(setEngineHash(card.dataset.swishPreviewOrderHash || ''));
    var summary = card.querySelector('[data-swish-preview-order-summary]');
    var summaryDescription = summary && summary.querySelector('p');
    var fixedDescription = JSON.stringify(String(summaryDescription && summaryDescription.textContent || ''));

    return '<scr' + 'ipt>(function(){' +
      'var activeMessageId=' + messageId + ',parentOrigin=' + parentOrigin + ',designUrl=' + designUrl + ',fallbackHash=' + fallbackHash + ',fixedDescription=' + fixedDescription + ',summaryMode=' + summaryMode + ',proxyFetchPending={},proxyFetchSequence=0,pendingCardContext=null,runtimeErrorReported=false,cardContextSequence=0,applyingCardContext=false,stateTimer=0,colorPresetRequestId=0,dimensionsEdited=false;' +
      'var summaryPresentation=' + summaryPresentation + ';' +
      'var applyPreviewSummaryPresentation=' + applyPreviewSummaryPresentation.toString() + ';' +
      'var syncOrderSummaryPresentation=' + syncOrderSummaryPresentation.toString() + ';' +
      'var bindPreviewSummaryPresentation=' + bindPreviewSummaryPresentation.toString() + ';' +
      'var syncPreviewHoopRemoval=' + syncPreviewHoopRemoval.toString() + ';' +
      'var overhangHelpMarkup=' + overhangHelpMarkup.toString() + ';' +
      'try{parent.SwishPreviewColumnOrdering.bindSummaryHelp(window);}catch(error){}' +
      'var applyColorPreset=' + applyColorPresetInEditor.toString() + ';' +
      'var post=function(data,transfer){try{data.id=activeMessageId;parent.postMessage(data,parentOrigin,transfer||[]);}catch(error){}};' +
      '(' + bindPreviewPopoverViewport.toString() + ')();' +
      'var previewTileSeriesPicker=(' + bindPreviewTileSeriesPicker.toString() + ')();' +
      'var reportRuntimeError=function(error){if(runtimeErrorReported)return;runtimeErrorReported=true;var message=error&&error.message?error.message:String(error||"Court editor failed to initialize.");post({type:"swish-preview-order-runtime-error",message:message});};' +
      // Measure natural content, including floating editors. Preserve its
      // fractional height so resting cards retain the surrounding spacing.
      'var sendHeight=function(){try{var body=document.body;var height=body?body.getBoundingClientRect().height:0;if(body&&body.scrollHeight>Math.ceil(height))height=body.scrollHeight;post({type:"swish-preview-order-height",height:height});}catch(error){}};' +
      'var syncPresentation=function(){try{syncOrderSummaryPresentation(summaryMode,summaryPresentation);syncPreviewHoopRemoval(document.querySelector("[data-swishcb-hoop-purchase]"));var description=document.querySelector("[data-swishcb-dynamic-product-description]");if(description&&fixedDescription)description.textContent=fixedDescription;var orderTotal=document.querySelector("[data-swishcb-order-price-total]");var productPrice=document.querySelector("[data-swish-preview-order-price]");var totalText=String(orderTotal&&orderTotal.textContent||"").trim();if(productPrice&&totalText&&totalText!=="Enter your court dimensions to calculate the total.")productPrice.textContent=totalText.replace(/\\s+[A-Z]{3}\\s*$/," ").trim();document.querySelectorAll(".swishcb__free-shipping").forEach(function(label){var text="Free shipping on tiles";if(label.textContent!==text)label.textContent=text;});}catch(error){}};' +
      'bindPreviewSummaryPresentation(syncPresentation);' +
      'var serializeHoopPurchaseUi=' + serializeHoopPurchaseUi.toString() + ';' +
      'var collectSummary=function(){var result={measurements:[],colors:[],tiles:[],logo:null,price:"",hoop:null};try{var builderRoot=document.querySelector("#swish-court-builder");result.edgeColorSource=builderRoot&&builderRoot.dataset.swishcbAutomaticEdgeSource||"main";var orderState=window.SwishCB&&window.SwishCB.ordering&&window.SwishCB.ordering.getState?window.SwishCB.ordering.getState(builderRoot):null;result.installedAreaM2=orderState&&Number.isFinite(orderState.areaM2)?orderState.areaM2:null;Array.prototype.forEach.call(document.querySelectorAll(".swishcb__order-specification"),function(group){var heading=group.dataset.swishPreviewOrderOriginalHeading||String(group.querySelector(".swishcb__order-specification-heading")&&group.querySelector(".swishcb__order-specification-heading").textContent||"").trim();var rows=group.querySelectorAll(".swishcb__order-specification-values>li");if(heading==="Measurements"){Array.prototype.forEach.call(rows,function(row){var input=row.querySelector("[data-swishcb-product-dimension-input],[data-swishcb-product-overhang-input]");if(!input)return;var label=row.dataset.swishPreviewOrderOriginalLabel||String(row.firstChild&&row.firstChild.nodeValue||"").replace(/:\\s*$/,"").trim();var editor=input.closest("[data-unit]");var unit=String(editor&&editor.dataset.unit||"m");result.measurements.push({label:label,value:String(input.value||"").trim()+" "+unit});});}else if(heading==="Colors"){Array.prototype.forEach.call(rows,function(row){var hex=row.querySelector(".swishcb__order-color-hex");var label=String(row.textContent||"").split(":")[0].trim();if(label&&hex)result.colors.push({label:label,value:String(hex.textContent||"").trim().toUpperCase()});});}else if(heading==="Tiles"){Array.prototype.forEach.call(rows,function(row,index){var text=String(row.textContent||"").trim();var label=text.split(":")[0].trim();var value=text.slice(text.indexOf(":")+1).trim();if(index===0){var selected=row.querySelector("select option:checked");value=String(selected&&selected.textContent||value).trim();}if(label)result.tiles.push({label:label,value:value});});}else if(heading==="Logos"){var logoText=String(rows[0]&&rows[0].textContent||"").replace(/^Logos:\\s*/,"").trim();var action=/\\bChange\\b$/.test(logoText)?"Change":"Upload";var state=logoText.replace(/\\s+(?:Upload|Change)$/,"").trim()||"None";result.logo={state:state,action:action};}});var orderTotal=document.querySelector("[data-swishcb-order-price-total]");var price=document.querySelector("[data-swish-preview-order-price]");var orderTotalText=String(orderTotal&&orderTotal.textContent||"").trim();result.price=orderTotalText&&orderTotalText!=="Enter your court dimensions to calculate the total."?orderTotalText:String(price&&price.textContent||"").trim();var purchase=document.querySelector("[data-swishcb-hoop-purchase]");if(purchase){var active=purchase.dataset.swishcbHoopPurchaseActive==="true";var modelSelect=purchase.querySelector("[data-swishcb-hoop-purchase-select]");var countSelect=document.querySelector("#swishcb-hoops-mode");result.hoop={markup:serializeHoopPurchaseUi(document),state:window.SwishCB&&window.SwishCB.ordering&&window.SwishCB.ordering.getPreviewHoopPurchaseState?window.SwishCB.ordering.getPreviewHoopPurchaseState(document.querySelector("#swish-court-builder")):null,active:active,eligible:purchase.dataset.swishcbHoopPurchaseEligible==="true",productUrl:String(purchase.querySelector("[data-swishcb-hoop-price-label]")&&purchase.querySelector("[data-swishcb-hoop-price-label]").getAttribute("href")||""),model:String(modelSelect&&modelSelect.selectedOptions&&modelSelect.selectedOptions[0]&&modelSelect.selectedOptions[0].textContent||"").trim(),count:String(countSelect&&countSelect.selectedOptions&&countSelect.selectedOptions[0]&&countSelect.selectedOptions[0].textContent||"").trim(),courtPrice:String(purchase.querySelector("[data-swishcb-court-tiles-price]")&&purchase.querySelector("[data-swishcb-court-tiles-price]").textContent||"").trim(),hoopPrice:String(purchase.querySelector("[data-swishcb-hoop-price]")&&purchase.querySelector("[data-swishcb-hoop-price]").textContent||"").trim()};}}catch(error){}return result;};' +
      'var sendState=function(expectedSequence,expectedId){try{if(applyingCardContext)return;if(expectedSequence!=null&&expectedSequence!==cardContextSequence)return;if(expectedId&&expectedId!==activeMessageId)return;var api=window.SwishCourtBuilder;if(api&&typeof api.refreshPreviewEdgeColor==="function")api.refreshPreviewEdgeColor();syncPresentation();var root=document.querySelector("#swish-court-builder");var logos=api&&typeof api.getPreviewLogos==="function"?api.getPreviewLogos():[];var hash=root&&typeof root.__swishcbBuildShareHashFromCurrentState==="function"?root.__swishcbBuildShareHashFromCurrentState():fallbackHash;var orderButton=document.querySelector("[data-swishcb-order-checkout]");var summary=collectSummary();if(logos.length)summary.logo={state:"Uploaded",action:"Change"};post({type:"swish-preview-order-state",hash:String(hash||fallbackHash),canOrder:!!(orderButton&&!orderButton.disabled),summary:summary,logos:logos,colorPresetRequestId:colorPresetRequestId,dimensionsEdited:dimensionsEdited});}catch(error){}};' +
      'var scheduleState=function(){if(applyingCardContext)return;clearTimeout(stateTimer);var sequence=cardContextSequence,id=activeMessageId;stateTimer=setTimeout(function(){if(sequence!==cardContextSequence||id!==activeMessageId)return;sendState(sequence,id);sendHeight();},80);};' +
      'var openEditor=function(editor,attempt){attempt=attempt||0;var root=document.querySelector("#swish-court-builder");if(!root||!editor)return false;var find=function(selector,predicate){return Array.prototype.find.call(root.querySelectorAll(selector),predicate)||null;};var target=null;if(editor.indexOf("dimension:")===0){var dimensionKind=editor.slice(10);target=find("[data-swishcb-product-dimension-input]",function(node){return node.dataset.swishcbDimensionKind===dimensionKind;});}else if(editor==="overhang"){target=root.querySelector("[data-swishcb-product-overhang-input]");}else if(editor==="series"){syncPresentation();if(previewTileSeriesPicker.open())return true;if(attempt<30)setTimeout(function(){openEditor(editor,attempt+1);},100);return false;}else if(editor==="hoop-model"){target=root.querySelector("[data-swishcb-hoop-purchase-select]");}else if(editor==="hoop-count"){target=root.querySelector("#swishcb-hoops-mode");}else if(editor==="hoop-remove"){target=root.querySelector("[data-swishcb-hoop-purchase-toggle]:checked");}else if(editor.indexOf("color:")===0){var colorId=editor.slice(6);target=find("[data-swishcb-order-color-swatch]",function(node){return node.dataset.swishcbOrderColorTargetKind==="base"&&node.dataset.swishcbOrderColorTargetId===colorId;});}else if(editor==="logo"){target=find("[data-swishcb-product-add-artwork]",function(node){return node.dataset.swishcbProductAddArtwork==="logo";});}if(!target){if(attempt<30)setTimeout(function(){openEditor(editor,attempt+1);},100);return false;}if(editor.indexOf("color:")===0||editor==="logo"||editor==="hoop-remove"){target.click();return true;}try{target.focus({preventScroll:true});}catch(error){try{target.focus();}catch(ignore){}}if(target.matches("input")){try{target.select();}catch(error){}}else if(target.matches("select")&&typeof target.showPicker==="function"){try{target.showPicker();}catch(error){}}return true;};' +
      'var waitForLogoLoad=function(attempt){attempt=attempt||0;try{var api=window.SwishCourtBuilder;var logos=api&&typeof api.getPreviewLogos==="function"?api.getPreviewLogos():[];if(logos&&logos.length){sendState();sendHeight();return true;}if(attempt<80){setTimeout(function(){waitForLogoLoad(attempt+1);},100);return false;}throw new Error("The selected logo did not finish loading.");}catch(error){reportRuntimeError(error);return false;}};' +
      'var applyLogoFile=function(payload,attempt){attempt=attempt||0;var api=window.SwishCourtBuilder;if(!api||typeof api.loadPreviewLogoFile!=="function"){if(attempt<80)setTimeout(function(){applyLogoFile(payload,attempt+1);},100);else reportRuntimeError(new Error("Logo upload control did not become ready."));return false;}try{var file=new File([payload.buffer],String(payload.name||"court-logo"),{type:String(payload.type||"application/octet-stream")});if(!api.loadPreviewLogoFile(file))throw new Error("The selected logo could not be loaded.");waitForLogoLoad(0);return true;}catch(error){reportRuntimeError(error);return false;}};' +
      'var logoEditorModeSequence=0;var setLogoEditorMode=function(active,attempt,sequence){attempt=attempt||0;if(sequence==null)sequence=++logoEditorModeSequence;if(sequence!==logoEditorModeSequence)return false;try{var api=window.SwishCourtBuilder;if(active){document.body.setAttribute("data-swish-preview-order-logo-editor-mode","true");if(!api||typeof api.openPreviewLogoEditor!=="function"){if(attempt<40)setTimeout(function(){setLogoEditorMode(true,attempt+1,sequence);},100);return false;}api.openPreviewLogoEditor();}else{document.body.removeAttribute("data-swish-preview-order-logo-editor-mode");if(api&&typeof api.closePreviewLogoEditor==="function")api.closePreviewLogoEditor();}try{dispatchEvent(new Event("resize"));}catch(error){}setTimeout(function(){if(sequence!==logoEditorModeSequence)return;try{dispatchEvent(new Event("resize"));}catch(error){}sendHeight();},80);return true;}catch(error){reportRuntimeError(error);return false;}};' +
      'var nativeFetch=window.fetch&&window.fetch.bind(window);' +
      'if(nativeFetch){window.fetch=async function(input,init){init=init||{};var url=new URL(typeof input==="string"?input:(input&&input.url)||"",window.location.href);if(url.origin==="https://swish-system-app.vercel.app"&&url.pathname.indexOf("/api/public/checkout/court")===0){var requestId=activeMessageId+"-"+(++proxyFetchSequence),headers={};try{new Headers(init.headers||{}).forEach(function(value,key){headers[key]=value;});}catch(error){}var payload={type:"swish-preview-order-fetch",requestId:requestId,url:url.href,method:String(init.method||"GET"),headers:headers,bodyKind:"text",body:""},transfer=[];if(init.body instanceof FormData){payload.bodyKind="form";payload.fields=[];for(var pair of init.body.entries()){if(pair[1] instanceof Blob){var buffer=await pair[1].arrayBuffer();payload.file={field:String(pair[0]),name:String(pair[1].name||"court-design.png"),type:String(pair[1].type||"application/octet-stream"),buffer:buffer};transfer.push(buffer);}else payload.fields.push([String(pair[0]),String(pair[1])]);}}else if(init.body!=null){payload.body=String(init.body);}var pending=new Promise(function(resolve,reject){proxyFetchPending[requestId]={resolve:resolve,reject:reject};});post(payload,transfer);var proxied=await pending;var raw=String(proxied.body||""),status=Number(proxied.status)||500,responseHeaders=proxied.headers||{};return{ok:status>=200&&status<300,status:status,statusText:"",url:url.href,headers:{get:function(name){var key=String(name||"").toLowerCase();return responseHeaders[key]||responseHeaders[String(name||"")]||null;}},json:async function(){return JSON.parse(raw);},text:async function(){return raw;}};}var response=await nativeFetch(input,init);try{var nativeJson=response.json.bind(response);response.json=async function(){var body=await nativeJson();if(body&&body.checkoutUrl){post({type:"swish-preview-order-checkout",url:String(body.checkoutUrl)});}return body;};}catch(error){}return response;};}' +
      'var applyCardContext=function(context,attempt){attempt=attempt||0;if(context){context.__swishContextSequence=++cardContextSequence;pendingCardContext=context;clearTimeout(stateTimer);}if(!pendingCardContext)return false;var api=window.SwishCourtBuilder;var root=document.querySelector("#swish-court-builder");if(!root||!api||typeof api.applyShareHash!=="function"){if(attempt<600)setTimeout(function(){applyCardContext(null,attempt+1);},100);else reportRuntimeError(new Error("Court editor timed out while loading."));return false;}context=pendingCardContext;var sequence=Number(context.__swishContextSequence)||cardContextSequence;if(sequence!==cardContextSequence)return false;pendingCardContext=null;applyingCardContext=true;dimensionsEdited=context.dimensionsEdited===true;activeMessageId=String(context.id||activeMessageId);var contextId=activeMessageId;designUrl=String(context.designUrl||designUrl);fallbackHash=String(context.hash||fallbackHash);fixedDescription=String(context.description||fixedDescription);summaryPresentation=Array.isArray(context.summaryPresentation)?context.summaryPresentation:summaryPresentation;summaryMode=context.summaryMode==="backyard"?"backyard":context.summaryMode==="simple"?"simple":"full";var presentation=document.querySelector("[data-swish-preview-order-presentation]");if(presentation&&typeof context.presentationCss==="string")presentation.textContent=context.presentationCss;root.setAttribute("data-swish-preview-order-context",contextId);root.setAttribute("data-default-share-hash",fallbackHash);root.setAttribute("data-share-base-url",designUrl.split("#")[0]);try{var ordering=window.SwishCB&&window.SwishCB.ordering;if(ordering&&ordering.restorePreviewHoopPurchaseState)ordering.restorePreviewHoopPurchaseState(root,null,{refresh:false});api.applyShareHash(fallbackHash,{canonicalize:false});colorPresetRequestId=0;if(context.colorPreset){applyColorPreset(context.colorPreset);colorPresetRequestId=Number(context.colorPreset.requestId)||0;}if(ordering&&ordering.restorePreviewHoopPurchaseState)ordering.restorePreviewHoopPurchaseState(root,context.hoopPurchase||null);}catch(error){applyingCardContext=false;pendingCardContext=context;if(attempt<600)setTimeout(function(){applyCardContext(null,attempt+1);},100);else reportRuntimeError(error);return false;}var completeContext=function(){if(sequence!==cardContextSequence||contextId!==activeMessageId)return;applyingCardContext=false;runtimeErrorReported=false;syncPresentation();try{dispatchEvent(new Event("resize"));}catch(error){}var emit=function(delay){setTimeout(function(){if(sequence!==cardContextSequence||contextId!==activeMessageId)return;syncPresentation();sendState(sequence,contextId);sendHeight();},delay);};emit(0);emit(120);emit(500);};if(typeof api.waitForPreviewLogos==="function"){Promise.resolve(api.waitForPreviewLogos()).then(completeContext).catch(function(error){if(sequence!==cardContextSequence||contextId!==activeMessageId)return;reportRuntimeError(error);});}else completeContext();return true;};' +
       'addEventListener("message",function(event){if(event.source!==parent)return;var data=event.data||{};if(data.type==="swish-preview-order-fetch-response"){var pending=proxyFetchPending[String(data.requestId||"")];if(pending){delete proxyFetchPending[String(data.requestId||"")];pending.resolve(data);}return;}if(data.type==="swish-preview-order-load-card"){applyCardContext(data,0);return;}if(data.id!==activeMessageId)return;if(data.type==="swish-preview-order-presentation"){var presentation=document.querySelector("[data-swish-preview-order-presentation]");if(presentation&&typeof data.css==="string"&&presentation.textContent!==data.css){presentation.textContent=data.css;sendHeight();}return;}if(data.type==="swish-preview-order-plan-render"){var planId=activeMessageId,planSequence=cardContextSequence,planApi=window.SwishCourtBuilder;if(planApi&&typeof planApi.getPreviewPlanSnapshot==="function"){Promise.resolve(planApi.getPreviewPlanSnapshot({width:data.width,height:data.height})).then(function(snapshot){if(planId!==activeMessageId||planSequence!==cardContextSequence||!snapshot||!snapshot.dataUrl)return;post({type:"swish-preview-order-plan-image",requestId:data.requestId,image:snapshot.dataUrl});}).catch(reportRuntimeError);}return;}if(data.type==="swish-preview-order-color-preset"){try{applyingCardContext=true;applyColorPreset(data.preset);colorPresetRequestId=Number(data.preset.requestId)||0;applyingCardContext=false;scheduleState();}catch(error){applyingCardContext=false;reportRuntimeError(error);}return;}if(data.type==="swish-preview-order-submit"){var button=document.querySelector("[data-swishcb-order-checkout]")||document.querySelector("[data-swishcb-v2-secure-checkout]");var root=document.querySelector("#swish-court-builder");var ordering=window.SwishCB&&window.SwishCB.ordering;var api=window.SwishCourtBuilder;var checkoutFailed=function(){post({type:"swish-preview-order-checkout-failed",id:activeMessageId});};var startOrder=function(){if(ordering&&typeof ordering.startCheckout==="function"){Promise.resolve(ordering.startCheckout(root,button)).then(function(started){if(started===false)checkoutFailed();}).catch(function(error){checkoutFailed();reportRuntimeError(error);});}else button.click();};if(button&&!button.disabled){if(api&&typeof api.prepareOrderEditorMedia==="function")Promise.resolve(api.prepareOrderEditorMedia()).then(startOrder).catch(function(error){checkoutFailed();reportRuntimeError(error);});else startOrder();}else checkoutFailed();}if(data.type==="swish-preview-order-hoop-change"){var change=data.change||{},ui=document.querySelector("[data-swishcb-hoop-purchase]"),add=ui&&ui.querySelector("[data-swishcb-hoop-purchase-toggle]"),select=ui&&ui.querySelector("[data-swishcb-hoop-purchase-select]");if(ui&&ui.dataset.swishcbHoopPurchaseEligible==="true"){if(typeof change.active==="boolean"&&add&&add.checked!==change.active)add.click();if(change.preset&&select&&Array.prototype.some.call(select.options,function(option){return option.value===change.preset;})){select.value=change.preset;select.dispatchEvent(new Event("change",{bubbles:true}));}scheduleState();}}if(data.type==="swish-preview-order-open-editor"){openEditor(String(data.editor||""),0);}if(data.type==="swish-preview-order-logo-file"){applyLogoFile(data.file||{},0);}if(data.type==="swish-preview-order-logo-editor-mode"){setLogoEditorMode(data.active===true,0);}});' +
      'addEventListener("swish:order-summary-changed",function(){syncPresentation();scheduleState();});' +
      'addEventListener("swish:order-eligibility-changed",scheduleState);' +
      'addEventListener("swish:dimensions-changed",function(event){var detail=event.detail||{};if(!applyingCardContext&&(detail.target==="width"||detail.target==="length")&&(detail.reason==="dimension-commit"||detail.reason==="size-stepper"))dimensionsEdited=true;scheduleState();});' +
      'addEventListener("swish:preview-checkout-ready",function(event){var url=event&&event.detail&&event.detail.checkoutUrl;if(url)post({type:"swish-preview-order-checkout",url:String(url)});});' +
      'document.addEventListener("input",scheduleState,true);document.addEventListener("change",scheduleState,true);' +
      'document.addEventListener("click",function(event){if(document.body.getAttribute("data-swish-preview-order-logo-editor-mode")!=="true")return;if(event.target&&event.target.closest&&event.target.closest("[data-product-logo-action]"))scheduleState();},true);' +
      'document.addEventListener("pointerup",function(){if(document.body.getAttribute("data-swish-preview-order-logo-editor-mode")==="true")scheduleState();},true);' +
      'document.addEventListener("keyup",function(){if(document.body.getAttribute("data-swish-preview-order-logo-editor-mode")==="true")scheduleState();},true);' +
      'addEventListener("error",function(event){reportRuntimeError(event&&event.error?event.error:new Error(String(event&&event.message||"Court editor script error.")));});' +
      'addEventListener("unhandledrejection",function(event){reportRuntimeError(event&&event.reason?event.reason:new Error("Court editor promise failed."));});' +
      'addEventListener("load",function(){syncPresentation();sendHeight();scheduleState();setTimeout(function(){syncPresentation();scheduleState();},300);setTimeout(function(){syncPresentation();scheduleState();},1400);setTimeout(function(){syncPresentation();scheduleState();},3200);});' +
      'if(window.ResizeObserver){var heightObserver=new ResizeObserver(sendHeight);heightObserver.observe(document.body);heightObserver.observe(document.documentElement);}if(document.fonts)document.fonts.ready.then(sendHeight);' +
    '})();<' + '/scr' + 'ipt>';
  }

  function safeCssValue(value, fallback) {
    var normalized = String(value || '').replace(/[\r\n{}]/g, ' ').replace(/<\/?style/gi, '').trim();
    return normalized || fallback;
  }

  function collectCardPresentationCss(card) {
    var summary = card && card.querySelector('[data-swish-preview-order-summary]');
    if (!summary || typeof window.getComputedStyle !== 'function') return '';

    var group = summary.querySelector('.swish-preview-order-card__summary-group');
    var heading = summary.querySelector('.swish-preview-order-card__summary-heading');
    var list = summary.querySelector('.swish-preview-order-card__summary-list');
    var listItem = list && list.querySelector('li');
    var swatch = summary.querySelector('.swish-preview-order-card__summary-swatch');
    var price = summary.querySelector('.swish-preview-order-card__summary-price');
    var shipping = summary.querySelector('.swish-preview-order-card__summary-shipping');
    var pricing = summary.querySelector('.swish-preview-order-card__summary-pricing');
    var shippingGap = pricing ? window.getComputedStyle(pricing).rowGap : '1rem';
    var hoopNote = summary.querySelector('.swishcb__hoop-not-included, .swish-preview-order-card__summary-hoop-note');
    var hoopToggle = summary.querySelector('.swishcb__hoop-purchase-toggle');
    var hoopPurchase = summary.querySelector('[data-swishcb-hoop-purchase]');
    var logoEdit = summary.querySelector('[data-swish-preview-order-editor="logo"]');
    var summaryStyle = window.getComputedStyle(summary);
    var groupStyle = window.getComputedStyle(group || summary);
    var headingStyle = window.getComputedStyle(heading || summary);
    var listStyle = window.getComputedStyle(list || summary);
    var listItemStyle = window.getComputedStyle(listItem || list || summary);
    var swatchStyle = swatch ? window.getComputedStyle(swatch) : null;
    var priceStyle = window.getComputedStyle(price || summary);
    var shippingStyle = window.getComputedStyle(shipping || summary);
    var shippingIconStyle = shipping ? window.getComputedStyle(shipping, '::before') : null;
    var hoopNoteStyle = window.getComputedStyle(hoopNote || summary);
    var hoopToggleStyle = window.getComputedStyle(hoopToggle || summary);
    var logoEditStyle = window.getComputedStyle(logoEdit || summary);
    var cardStyle = window.getComputedStyle(card);

    var background = safeCssValue(cardStyle.backgroundColor, 'rgb(255, 255, 255)');
    if (background === 'rgba(0, 0, 0, 0)' || background === 'transparent') background = 'rgb(255, 255, 255)';

    var bodyFont =
      'font-family:' + safeCssValue(summaryStyle.fontFamily, 'inherit') + '!important;' +
      'font-size:' + safeCssValue(summaryStyle.fontSize, 'inherit') + '!important;' +
      'font-style:' + safeCssValue(summaryStyle.fontStyle, 'normal') + '!important;' +
      'font-weight:' + safeCssValue(summaryStyle.fontWeight, '400') + '!important;' +
      'letter-spacing:' + safeCssValue(summaryStyle.letterSpacing, 'normal') + '!important;' +
      'line-height:' + safeCssValue(summaryStyle.lineHeight, 'normal') + '!important;' +
      'color:' + safeCssValue(summaryStyle.color, 'inherit') + '!important;';
    var headingFont =
      'font-family:' + safeCssValue(headingStyle.fontFamily, 'inherit') + '!important;' +
      'font-size:' + safeCssValue(headingStyle.fontSize, 'inherit') + '!important;' +
      'font-style:' + safeCssValue(headingStyle.fontStyle, 'normal') + '!important;' +
      'font-weight:' + safeCssValue(heading ? headingStyle.fontWeight : '600', '600') + '!important;' +
      'letter-spacing:' + safeCssValue(headingStyle.letterSpacing, 'normal') + '!important;' +
      'line-height:' + safeCssValue(headingStyle.lineHeight, 'normal') + '!important;' +
      'color:' + safeCssValue(headingStyle.color, 'inherit') + '!important;';
    var listFont =
      'font-family:' + safeCssValue(listItemStyle.fontFamily, 'inherit') + '!important;' +
      'font-size:' + safeCssValue(listItemStyle.fontSize, 'inherit') + '!important;' +
      'font-style:' + safeCssValue(listItemStyle.fontStyle, 'normal') + '!important;' +
      'font-weight:' + safeCssValue(listItemStyle.fontWeight, '400') + '!important;' +
      'letter-spacing:' + safeCssValue(listItemStyle.letterSpacing, 'normal') + '!important;' +
      'line-height:' + safeCssValue(listItemStyle.lineHeight, 'normal') + '!important;' +
      'color:' + safeCssValue(listItemStyle.color, 'inherit') + '!important;';

    // Inline measurement triggers keep their wrapper's dotted underline.
    // Two root IDs outrank the shared form-field shadow without touching dialogs.
    var inlineMeasurementCss = '#swish-court-builder#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications :is([data-swishcb-product-dimension-input],[data-swishcb-product-overhang-input]){-webkit-appearance:none!important;appearance:none!important;border:0!important;border-radius:0!important;outline:none!important;box-shadow:none!important;background:transparent!important;}';

    var css = inlineMeasurementCss +
      'html{font-size:' + safeCssValue(window.getComputedStyle(document.documentElement).fontSize, '10px') + '!important;}' +
      'body{display:block!important;height:auto!important;min-height:0!important;' + bodyFont + 'background:' + background + '!important;}' +
      'body>.shopify-section,product-info.main-product,product-info.main-product>.page-width,#swish-court-builder,#swish-court-builder .product,#swish-court-builder .product__info-wrapper,#swish-court-builder .product__info-container{background:' + background + '!important;' + bodyFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card [data-swishcb-dynamic-product-description]{display:none!important;margin:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications{display:grid!important;gap:' + safeCssValue(summaryStyle.rowGap, '1.5rem') + '!important;margin:0!important;padding:0!important;' + bodyFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification{display:grid!important;gap:' + safeCssValue(groupStyle.rowGap, '0.6rem') + '!important;margin:0!important;padding:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification-heading{margin:' + safeCssValue(headingStyle.margin, '0') + '!important;padding:' + safeCssValue(headingStyle.padding, '0') + '!important;' + headingFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card [data-swish-preview-order-logo-picker]{cursor:pointer;font:' + safeCssValue(logoEditStyle.font, 'inherit') + '!important;letter-spacing:' + safeCssValue(logoEditStyle.letterSpacing, 'normal') + '!important;color:' + safeCssValue(logoEditStyle.color, 'inherit') + '!important;background:' + safeCssValue(logoEditStyle.backgroundColor, 'transparent') + '!important;padding:' + safeCssValue(logoEditStyle.padding, '0') + '!important;border:' + safeCssValue(logoEditStyle.border, '0') + '!important;border-bottom:' + safeCssValue(logoEditStyle.borderBottom, '0.15rem dotted currentColor') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification-values{display:grid!important;gap:' + safeCssValue(listStyle.rowGap, '0.35rem') + '!important;margin:0!important;padding-inline-start:' + safeCssValue(listStyle.paddingInlineStart, '1.25em') + '!important;list-style-type:circle!important;' + listFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification-values>li{' + listFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification-values>li::marker{color:' + safeCssValue(listItemStyle.color, 'inherit') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__info-container>[id^="price-"]{display:block!important;margin:' + safeCssValue(summaryStyle.rowGap, '1.5rem') + ' 0 0!important;padding:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__info-container>[id^="price-"] .price,#swish-court-builder.swishcb--preview-order-card .product__info-container>[id^="price-"] .price__container,#swish-court-builder.swishcb--preview-order-card .product__info-container>[id^="price-"] .price__regular{display:block!important;line-height:inherit!important;margin:0!important;padding:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card [data-swish-preview-order-price]{display:block!important;font-family:' + safeCssValue(priceStyle.fontFamily, 'inherit') + '!important;font-size:' + safeCssValue(priceStyle.fontSize, '22px') + '!important;font-style:' + safeCssValue(priceStyle.fontStyle, 'normal') + '!important;font-weight:' + safeCssValue(priceStyle.fontWeight, '400') + '!important;letter-spacing:' + safeCssValue(priceStyle.letterSpacing, 'normal') + '!important;line-height:1.2!important;color:' + safeCssValue(priceStyle.color, 'inherit') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__tax[data-swishcb-v2-order-content]{display:grid!important;gap:' + safeCssValue(shippingGap, '1rem') + '!important;margin:' + safeCssValue(shippingGap, '1rem') + ' 0 0!important;padding:0!important;' + bodyFont + '}' +
      '#swish-court-builder.swishcb--preview-order-card .product__tax[data-swishcb-v2-order-content]::after{display:none!important;content:none!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__tax[data-swishcb-v2-order-content] p{margin:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__free-shipping{display:none!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__tax[data-swishcb-v2-order-content] p:has(>.swishcb__free-shipping){display:none!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .product__tax[data-swishcb-v2-order-content]:has(.swishcb__free-shipping):not(:has([data-swishcb-hoop-purchase-active="true"])){display:none!important;margin:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase{' + (hoopPurchase ? '' : 'display:none!important;') + 'margin:0!important;padding:0!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase-toggle{margin:0!important;padding:0!important;font-family:' + safeCssValue(hoopToggleStyle.fontFamily, 'inherit') + '!important;font-size:' + safeCssValue(hoopToggleStyle.fontSize, 'inherit') + '!important;font-style:' + safeCssValue(hoopToggleStyle.fontStyle, 'normal') + '!important;font-weight:' + safeCssValue(hoopToggleStyle.fontWeight, '400') + '!important;letter-spacing:' + safeCssValue(hoopToggleStyle.letterSpacing, 'normal') + '!important;line-height:' + safeCssValue(hoopToggleStyle.lineHeight, 'normal') + '!important;color:' + safeCssValue(hoopToggleStyle.color, 'inherit') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase-active{margin-top:' + safeCssValue(summaryStyle.rowGap, '1.5rem') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-price-breakdown strong{font-weight:400!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-not-included{font-family:' + safeCssValue(hoopNoteStyle.fontFamily, 'inherit') + '!important;font-size:' + safeCssValue(hoopNoteStyle.fontSize, 'inherit') + '!important;font-style:' + safeCssValue(hoopNoteStyle.fontStyle, 'normal') + '!important;font-weight:400!important;letter-spacing:' + safeCssValue(hoopNoteStyle.letterSpacing, 'normal') + '!important;line-height:' + safeCssValue(hoopNoteStyle.lineHeight, 'normal') + '!important;color:' + safeCssValue(hoopNoteStyle.color, 'inherit') + '!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-not-included strong{font-weight:inherit!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase:not([data-swishcb-hoop-purchase-active="true"]),#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase-toggle,#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-not-included{display:none!important;}' +
      '#swish-court-builder.swishcb--preview-order-card .swishcb__hoop-purchase-link{height:auto!important;border:0!important;background:transparent!important;padding:0!important;text-decoration:underline!important;text-underline-offset:.2rem!important;line-height:inherit!important;color:inherit!important;font:inherit!important;font-weight:400!important;}' +
      'body #swish-court-builder.swishcb--preview-order-card .swishcb__controls{display:none!important;height:0!important;margin:0!important;padding:0!important;}';

    if (shippingIconStyle) {
      css += '#swish-court-builder.swishcb--preview-order-card .swishcb__free-shipping::before{' +
        'content:"";flex:0 0 ' + safeCssValue(shippingIconStyle.width, '2.6rem') + ';' +
        'width:' + safeCssValue(shippingIconStyle.width, '2.6rem') + ';height:' + safeCssValue(shippingIconStyle.height, '2.6rem') + ';background-color:currentColor;' +
        '-webkit-mask:' + safeCssValue(shippingIconStyle.maskImage, 'none') + ' center / contain no-repeat;' +
        'mask:' + safeCssValue(shippingIconStyle.maskImage, 'none') + ' center / contain no-repeat;}';
    }

    if (swatchStyle) {
      css += '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-color-swatch{' +
        'width:' + safeCssValue(swatchStyle.width, '1.5em') + '!important;' +
        'height:' + safeCssValue(swatchStyle.height, '1.5em') + '!important;' +
        'flex:0 0 ' + safeCssValue(swatchStyle.width, '1.5em') + '!important;' +
        'border:' + safeCssValue(swatchStyle.border, '0.1rem solid rgba(0,0,0,.2)') + '!important;' +
        'border-radius:' + safeCssValue(swatchStyle.borderRadius, '0.35rem') + '!important;' +
      '}';
    }

    // Summary visibility is presentation only: keep the native settings and
    // payload nodes intact so pricing, edits and Design retain the full court.
    var hiddenDetails = String(card.dataset.swishPreviewOrderHiddenDetails || '').split(/\s+/);
    var hiddenSelectors = {
      'additional-sports': '[data-swish-preview-order-detail="additional-sports"]',
      colors: '[data-swish-preview-order-detail="colors"]',
      logos: '[data-swish-preview-order-detail="logos"]',
      'three-point': '[data-swish-preview-order-detail="three-point"]',
      'tile-series': '[data-swish-preview-order-series]'
    };
    hiddenDetails.forEach(function (detail) {
      if (hiddenSelectors[detail]) {
        css += '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications ' +
          hiddenSelectors[detail] + '{display:none!important;}';
      }
    });
    return css;
  }

  function buildFrameDocument(sectionHtml, card, initialMessageId) {
    var preset = card.dataset.swishPreviewOrderHash || '';
    var designUrl = card.dataset.swishPreviewOrderDesignUrl || '';
    var maxCheckoutArea = Number(card.dataset.swishPreviewOrderMaxAreaM2 || 0);
    // The embedded summary displays the ordering quote. Keep its price node
    // separate from the main app's tile-selection price renderer.
    var html = setBuilderRootAttributes(sectionHtml, preset, designUrl, initialMessageId || card.dataset.swishPreviewOrderMessageId)
      .replace(/data-swishcb-product-price(?=[\s=>])/g, 'data-swish-preview-order-price')
      .replace(/(["'])\/cdn\/3d\/models\//g, '$1https://cdn.shopify.com/3d/models/');
    if (Number.isFinite(maxCheckoutArea) && maxCheckoutArea >= 0) {
      html = html.replace(
        /data-swishcb-order-max-area-m2="[^"]*"/,
        'data-swishcb-order-max-area-m2="' + escapeAttribute(String(maxCheckoutArea)) + '"'
      );
    }

    return '<!doctype html><html><head>' +
      '<meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<base href="' + escapeAttribute(window.location.origin + '/') + '">' +
      collectThemeFoundationMarkup() +
      '<style>' +
        'html,body{display:block!important;height:auto!important;min-height:0!important;margin:0;padding:0;background:transparent;overflow-x:hidden}' +
        // This is a summary in the surrounding page, not a second scroll area.
        // Keep transient scrollbars off while its measured height is updated.
        'html,body{overflow:hidden!important}' +
        'body>.shopify-section{margin:0}' +
        'product-info.main-product{padding:0!important}' +
        'product-info.main-product>.page-width{max-width:none!important;padding:0!important}' +
        '#swish-court-builder{--swishcb-preview-column-width:100%!important}' +
        '#swish-court-builder .product{display:block!important;margin:0!important}' +
        '#swish-court-builder .product__media-wrapper{display:none!important}' +
        '#swish-court-builder .product__info-wrapper{display:block!important;width:100%!important;max-width:100%!important;padding:0!important}' +
        '#swish-court-builder .product__info-container{max-width:none!important}' +
        '#swish-court-builder .product__title,#swish-court-builder .swishcb__controls,#swish-court-builder details[data-swishcb-panel="order-now"],#swish-court-builder [data-swishcb-panel="contact"],#swish-court-builder [data-swishcb-panel="faq"],#swish-court-builder [data-swishcb-order-series-details]{display:none!important}' +
        '#swish-court-builder [data-swishcb-design-court-block]{display:none!important}' +
        '#swish-court-builder .swishcb__hoop-purchase-select:focus{border-color:rgb(var(--color-foreground));box-shadow:inset 0 0 0 1px rgb(var(--color-foreground))}' +
        // Hide the installment wrapper too; its theme margin survives hiding the form.
        '#swish-court-builder [data-swishcb-v2-order-content]:has([data-swishcb-v2-secure-checkout]),#swish-court-builder [data-swishcb-v2-order-content]:has(>.installment),#swish-court-builder .installment{display:none!important}' +
        '#swish-court-builder .product__text{margin-top:0!important}' +
        '#swish-court-builder .swishcb__product-order-specifications{margin-top:1.5rem!important}' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-specification-values{list-style-type:circle!important}' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-color-row{display:block!important}' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-color-text{display:flex!important;align-items:center;gap:.45em;min-width:0;overflow-wrap:normal}' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications .swishcb__order-color-swatch{flex:0 0 24px}' +
        'html:has(body[data-swish-preview-order-logo-editor-mode="true"]){height:100%!important;min-height:100%!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"]{height:100%!important;min-height:100%!important;overflow:hidden!important;background:#fff!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"]> .shopify-section,body[data-swish-preview-order-logo-editor-mode="true"] product-info.main-product,body[data-swish-preview-order-logo-editor-mode="true"] product-info.main-product>.page-width,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .product{height:100%!important;min-height:0!important;margin:0!important;padding:0!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .product__media-wrapper{display:block!important;width:100%!important;max-width:none!important;height:100%!important;min-height:0!important;margin:0!important;padding:0!important;position:relative!important;left:auto!important;top:auto!important;overflow:hidden!important;pointer-events:auto!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .product__info-wrapper{display:none!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-view="2d"]{display:block!important;width:100%!important;height:100%!important;min-height:0!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-view="3d"],body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .swishcb__toolbar{display:none!important}' +
      '</style><style data-swish-preview-order-presentation>' + collectCardPresentationCss(card) + '</style><style>' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications [data-swish-preview-simple-hidden]{display:none!important}' +
        '#swish-court-builder.swishcb--preview-order-card .swishcb__product-order-specifications [data-swish-preview-native-logo-hidden]{display:none!important}' +
        'html:has(body[data-swish-preview-order-logo-editor-mode="true"]),html:has(body[data-swish-preview-order-logo-editor-mode="true"]) body,body[data-swish-preview-order-logo-editor-mode="true"]>.shopify-section,body[data-swish-preview-order-logo-editor-mode="true"] product-info.main-product,body[data-swish-preview-order-logo-editor-mode="true"] product-info.main-product>.page-width,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .product,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .product__media-wrapper,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .swishcb__stage{height:100%!important;min-height:100%!important;background:transparent!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .product__media-wrapper [data-view="2d"].swishcb__viewport,body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .product__media-wrapper [data-view="2d"].swishcb__viewport .swishcb__product-logo-editor:not([hidden]){display:block!important;width:100%!important;height:100%!important;min-height:100%!important;background:transparent!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder#swish-court-builder .product__media-wrapper [data-view="2d"].swishcb__viewport>canvas{display:block!important;width:100%!important;height:100%!important;opacity:1!important;background:rgb(var(--color-background,255 255 255))!important}' +
        '@media(max-width:420px){body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .swishcb__product-logo-toolbar{display:grid!important;grid-template-columns:repeat(6,minmax(0,1fr));width:calc(100% - 16px);max-width:360px}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .swishcb__product-logo-toolbar button{width:100%!important;min-width:0!important;height:44px;min-height:44px;padding-inline:3px!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-product-logo-action="background"],body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-product-logo-action="color-overlay"]{font-size:11px!important;line-height:1.1;white-space:normal!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .swishcb__product-logo-color-dot{display:none}}' +
        '@media(max-width:260px){body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder .swishcb__product-logo-toolbar button{padding-inline:1px!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-product-logo-action="background"]{font-size:0!important}' +
        'body[data-swish-preview-order-logo-editor-mode="true"] #swish-court-builder [data-product-logo-action="background"]::after{content:"BG";font-size:11px}}' +
      '</style>' +
      '</he' + 'ad><body>' + html + childBootstrapMarkup(card, initialMessageId) + '</bo' + 'dy></ht' + 'ml>';
  }

  function extractBuilderSection(pageHtml) {
    var parsed = new DOMParser().parseFromString(String(pageHtml || ''), 'text/html');
    var root = parsed.querySelector('#swish-court-builder.swishcb--summary-advanced') || parsed.querySelector('#swish-court-builder');
    if (!root) throw new Error('No court builder was found on the selected source page.');
    // These preview cards own their line visibility. Do not inherit the source
    // product page's permanently hidden arcs into the shared editor.
    root.dataset.lockedHiddenDetails = String(root.dataset.lockedHiddenDetails || '').split(',').filter(function (id) {
      return id && PREVIEW_BASKETBALL_ARC_IDS.indexOf(id.trim()) < 0;
    }).join(',');
    var section = root.closest('.shopify-section') || root.closest('product-info') || root;
    // External script elements parsed out of another page are not a reliable
    // indication that their code executed. Leaving them in place makes the
    // builder's ordered loader incorrectly reuse inert nodes. Keep the inline
    // configuration/loader scripts and let that loader install every external
    // dependency once, in its validated order.
    Array.prototype.forEach.call(section.querySelectorAll('script[src]'), function (script) {
      var source = String(script.getAttribute('src') || '').toLowerCase();
      // Keep config before the deferred line packs in the extracted document.
      // They need its procedural helper before the inline loader starts after
      // DOMContentLoaded; otherwise they retain an empty drawing API.
      var isApplicationScript = /(?:swishcb-config|swishcb-pricing|swishcb-ordering(?:-[a-z0-9-]+)?|swishcb-hoop-info|swishcb-tooltips|swishcb-product-summary|swishcb-linepack-[a-z0-9-]+|swish-system-intake|swish-court-builder-contact|quick-add)\.js/.test(source);
      if (!isApplicationScript) script.remove();
    });
    return section.outerHTML;
  }

  function loadBuilderMarkup(sourceUrl, designUrl) {
    var url = new URL(String(sourceUrl || ''), window.location.href);
    url.hash = '';
    // A merchant can replace the contents of the original source page. The
    // card's Design link still identifies the builder that owns this court.
    var fallback = new URL(String(designUrl || '/pages/fiba-basketball-court-flooring?view=fiba-court-builder-temp'), window.location.href);
    fallback.hash = '';
    // This dedicated view preserves compact ordering and optional hoop controls.
    fallback.searchParams.set('view', 'swish-order-editor');
    // Keep the lazy editor in the same Shopify market as its server-rendered
    // preview, including country links before localization cookies are saved.
    var purchase = document.querySelector('[data-swishcb-hoop-purchase-country]');
    var country = String(purchase && purchase.dataset.swishcbHoopPurchaseCountry || window.Shopify && window.Shopify.country || '').toUpperCase();
    if (/^[A-Z]{2}$/.test(country)) {
      url.searchParams.set('country', country);
      fallback.searchParams.set('country', country);
    }
    var key = url.href + '|' + fallback.href;
    if (!builderMarkupByUrl[key]) {
      var fetchSection = function (target) {
        return window.fetch(target, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Builder page request failed with status ' + response.status);
          return response.text();
        })
        .then(extractBuilderSection);
      };
      builderMarkupByUrl[key] = fetchSection(url.href)
        .catch(function (error) {
          if (fallback.href === url.href) throw error;
          return fetchSection(fallback.href);
        })
        .catch(function (error) {
          delete builderMarkupByUrl[key];
          throw error;
        });
    }
    return builderMarkupByUrl[key];
  }

  function showError(card, error) {
    clearInlineLoading(card);
    card.dataset.swishPreviewOrderLoading = 'false';
    card.classList.add('has-error');
    card.classList.remove('is-loading');
    var status = card.querySelector('[data-swish-preview-order-status]');
    if (status) {
      status.hidden = false;
      status.textContent = error && error.message ? error.message : 'Court information could not be loaded.';
    }
    var submit = card.querySelector('[data-swish-preview-order-submit]');
    if (submit) {
      setPreviewCheckoutLoading(card, false);
      submit.disabled = false;
      submit.classList.remove('loading');
    }
  }

  function setPreviewCheckoutLoading(card, loading) {
    if (!card) return;
    var submit = card.querySelector('[data-swish-preview-order-submit]');
    if (!submit) return;
    if (!submit.dataset.swishPreviewOrderLabel) {
      submit.dataset.swishPreviewOrderLabel = String(submit.textContent || 'Order Now').trim();
    }
    if (loading && card.dataset.swishPreviewOrderCheckoutLoading !== 'true') {
      submit.dataset.swishPreviewOrderWasDisabled = submit.disabled ? 'true' : 'false';
    }
    card.dataset.swishPreviewOrderCheckoutLoading = loading ? 'true' : 'false';
    submit.textContent = loading ? 'Loading...' : submit.dataset.swishPreviewOrderLabel;
    submit.classList.remove('loading');
    submit.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
    } else {
      submit.disabled = submit.dataset.swishPreviewOrderWasDisabled === 'true';
      if (submit.disabled) submit.setAttribute('aria-disabled', 'true');
      else submit.removeAttribute('aria-disabled');
      delete submit.dataset.swishPreviewOrderWasDisabled;
    }
  }

  function submitFrameOrder(entry, messageId) {
    var frame = entry && entry.frame;
    if (!frame || !frame.contentWindow) return false;
    if (entry.card.dataset.swishPreviewOrderCustomQuote === 'true') return false;
    frame.contentWindow.postMessage({ type: 'swish-preview-order-submit', id: String(messageId || '') }, '*');
    return true;
  }

  function proxyPreviewOrderFetch(entry, data) {
    var requestId = String(data.requestId || '');
    var frameWindow = entry && entry.frame && entry.frame.contentWindow;
    if (!requestId || !frameWindow) return;
    var respond = function (payload) {
      frameWindow.postMessage(Object.assign({
        type: 'swish-preview-order-fetch-response',
        id: String(data.id || ''),
        requestId: requestId
      }, payload), '*');
    };
    var target;
    try { target = new URL(String(data.url || '')); } catch (_) {}
    if (!target || target.origin !== 'https://swish-system-app.vercel.app' || target.pathname.indexOf('/api/public/checkout/court') !== 0) {
      respond({ status: 400, body: JSON.stringify({ message: 'Invalid checkout service request.' }), headers: { 'content-type': 'application/json' } });
      return;
    }
    var headers = Object.assign({}, data.headers || {});
    var init = { method: String(data.method || 'POST'), headers: headers, credentials: 'omit' };
    if (data.bodyKind === 'form') {
      var formData = new FormData();
      Array.prototype.forEach.call(data.fields || [], function (pair) {
        if (Array.isArray(pair) && pair.length > 1) formData.append(String(pair[0]), String(pair[1]));
      });
      if (data.file && data.file.buffer) {
        formData.append(
          String(data.file.field || 'file'),
          new Blob([data.file.buffer], { type: String(data.file.type || 'application/octet-stream') }),
          String(data.file.name || 'court-design.png')
        );
      }
      delete init.headers['content-type'];
      delete init.headers['Content-Type'];
      init.body = formData;
    } else if (data.body != null && String(data.body) !== '') {
      init.body = String(data.body);
    }
    window.fetch(target.href, init).then(function (response) {
      return response.text().then(function (body) {
        respond({
          status: response.status,
          body: body,
          headers: { 'content-type': response.headers.get('content-type') || 'application/json' }
        });
      });
    }).catch(function (error) {
      respond({
        status: 599,
        body: JSON.stringify({ message: error && error.message ? error.message : 'Checkout service request failed.' }),
        headers: { 'content-type': 'application/json' }
      });
    });
  }

  function getCardEntry(card) {
    var messageId = String(card && card.dataset.swishPreviewOrderMessageId || '');
    return messageId ? cardsByMessageId[messageId] : null;
  }

  function configureOrderingPreviewTile(card) {
    var item = card && card.closest ? card.closest('.swish-preview-column__item') : null;
    var tile = item && item.querySelector('[data-swishcb-preview]');
    if (!tile) return null;

    // Ordering cards represent the physical tiled court. Keep the preview and
    // its resting poster on the same high-resolution builder configuration.
    if (!tile.hasAttribute('data-swishcb-poster-scale')) {
      tile.setAttribute('data-swishcb-poster-scale', '2');
    }
    if (!tile.hasAttribute('data-swishcb-tile-grid')) {
      tile.setAttribute('data-swishcb-tile-grid', '1');
    }
    // Resolve the grid from the current design, including later editor updates.
    tile.setAttribute('data-swishcb-tile-grid-series', 'from_hash');
    if (!tile.hasAttribute('data-swishcb-tile-grid-opacity')) {
      tile.setAttribute('data-swishcb-tile-grid-opacity', '0.18');
    }
    return { item: item, tile: tile };
  }

  function buildCardContext(card) {
    return {
      type: 'swish-preview-order-load-card',
      id: String(card.dataset.swishPreviewOrderMessageId || ''),
      hash: setEngineHash(card.dataset.swishPreviewOrderCurrentHash || card.dataset.swishPreviewOrderHash || ''),
      colorPreset: getCardEntry(card) && getCardEntry(card).pendingColorPreset || null,
      hoopPurchase: card._swishPreviewOrderCanonicalSummary && card._swishPreviewOrderCanonicalSummary.hoop
        ? card._swishPreviewOrderCanonicalSummary.hoop.state : null,
      designUrl: String(card.dataset.swishPreviewOrderDesignUrl || ''),
      summaryMode: card.dataset.swishPreviewOrderSummaryMode || 'full',
      summaryPresentation: getCardSummaryPresentation(card),
      presentationCss: collectCardPresentationCss(card),
      dimensionsEdited: card._swishPreviewOrderDimensionsEdited === true,
      description: ''
    };
  }

  function sendActiveCardContext() {
    if (!sharedEditorFrame || !sharedEditorFrame.contentWindow || !sharedEditorActiveEntry) return false;
    sharedEditorFrame.contentWindow.postMessage(buildCardContext(sharedEditorActiveEntry.card), '*');
    return true;
  }

  function refreshActiveCardPresentation() {
    if (!sharedEditorFrame || !sharedEditorFrame.contentWindow || !sharedEditorActiveEntry) return;
    var card = sharedEditorActiveEntry.card;
    sharedEditorFrame.contentWindow.postMessage({
      type: 'swish-preview-order-presentation',
      id: card.dataset.swishPreviewOrderMessageId,
      css: collectCardPresentationCss(card)
    }, '*');
  }

  window.addEventListener('resize', refreshActiveCardPresentation, { passive: true });
  if (document.fonts) document.fonts.ready.then(refreshActiveCardPresentation);

  function deactivateSharedEditorCard(nextEntry) {
    var previous = sharedEditorActiveEntry;
    if (!previous || previous === nextEntry) return;
    if (previous.logoEditorActive || previous.logoEditorRequested) exitLogoEditor(previous);
    previous.frame = null;
    previous.card.classList.remove('is-ready', 'is-loading', 'has-error');
    previous.card.dataset.swishPreviewOrderLoading = 'false';
    previous.pendingEditor = '';
    previous.pendingHoopChange = null;
    previous.card.dataset.swishPreviewOrderPendingHoop = 'false';
    previous.card.dataset.swishPreviewOrderPendingSubmit = 'false';
    clearInlineLoading(previous.card);
  }

  function ensureFrame(card) {
    if (sharedEditorActiveEntry && sharedEditorActiveEntry.finishPlan) {
      return sharedEditorActiveEntry.planPromise.then(function () { return ensureFrame(card); });
    }
    var sourceUrl = String(card.dataset.swishPreviewOrderSourceUrl || '');
    var sourceKey;
    try {
      var normalizedSource = new URL(sourceUrl, window.location.href);
      normalizedSource.hash = '';
      var normalizedDesign = new URL(String(card.dataset.swishPreviewOrderDesignUrl || ''), window.location.href);
      normalizedDesign.hash = '';
      sourceKey = normalizedSource.href + '|' + normalizedDesign.href;
    } catch (_) {
      sourceKey = sourceUrl;
    }

    var entry = getCardEntry(card);
    var slot = card.querySelector('[data-swish-preview-order-frame-slot]');
    if (!entry || !slot) return Promise.reject(new Error('Court editor host was not found.'));
    deactivateSharedEditorCard(entry);
    sharedEditorActiveEntry = entry;

    if (!sharedEditorFrame) {
      sharedEditorFrame = document.createElement('iframe');
      sharedEditorFrame.className = 'swish-preview-order-card__frame';
      sharedEditorFrame.setAttribute('data-swish-preview-order-frame', '');
      sharedEditorFrame.setAttribute('scrolling', 'no');
      sharedEditorFrame.setAttribute('loading', 'eager');
      sharedEditorFrame.addEventListener('load', function () {
        sendActiveCardContext();
      });
    }

    entry.frame = sharedEditorFrame;
    sharedEditorFrame.setAttribute('title', slot.dataset.frameTitle || 'Configure court');
    sharedEditorFrame.removeAttribute('tabindex');
    slot.appendChild(sharedEditorFrame);

    if (!sharedEditorDocumentPromise || sharedEditorSourceUrl !== sourceKey) {
      sharedEditorSourceUrl = sourceKey;
      var sequence = ++sharedEditorLoadSequence;
      sharedEditorDocumentPromise = loadBuilderMarkup(sourceUrl, card.dataset.swishPreviewOrderDesignUrl)
        .then(function (sectionHtml) {
          if (sequence !== sharedEditorLoadSequence) return sharedEditorFrame;
          sharedEditorFrame.srcdoc = buildFrameDocument(sectionHtml, card, '__swish-preview-prewarm__');
          return sharedEditorFrame;
        })
        .catch(function (error) {
          if (sequence === sharedEditorLoadSequence) {
            sharedEditorDocumentPromise = null;
            sharedEditorSourceUrl = '';
          }
          throw error;
        });
    }

    return sharedEditorDocumentPromise.then(function () {
      sendActiveCardContext();
      return sharedEditorFrame;
    });
  }

  function loadCard(card) {
    if (!card) return;
    var entry = getCardEntry(card);
    if (!entry) return;
    if (entry.loadPromise) {
      if (sharedEditorActiveEntry === entry && card.dataset.swishPreviewOrderLoading === 'true') sendActiveCardContext();
      return entry.loadPromise;
    }
    card.dataset.swishPreviewOrderLoading = 'true';
    card.classList.add('is-loading');
    // Every card gets its canonical totals and (when requested) a finished 2D
    // image before the summary editor moves on. Rapid clicks cannot cancel the
    // previous card's initial state or leave its plan permanently loading.
    entry.loadPromise = sharedEditorQueue.catch(function () {}).then(function () {
      return new Promise(function (resolve, reject) {
        entry.finishLoad = function (error) {
          clearTimeout(entry.loadTimer);
          entry.finishLoad = null;
          if (error) reject(error); else resolve(true);
        };
        entry.loadTimer = setTimeout(function () {
          if (entry.finishLoad) entry.finishLoad(new Error('Court editor timed out while loading.'));
        }, 45000);
        ensureFrame(card).catch(function (error) { if (entry.finishLoad) entry.finishLoad(error); });
      });
    })
      .catch(function (error) {
        console.error('[Swish preview ordering card]', error);
        showError(card, error);
      })
      .finally(function () {
        entry.loadPromise = null;
      });
    sharedEditorQueue = entry.loadPromise;
    return entry.loadPromise;
  }

  function clearInlineLoading(card) {
    if (!card) return;
    var loading = card.querySelector('[data-swish-preview-order-inline-loading]');
    if (loading) loading.remove();
    Array.prototype.forEach.call(card.querySelectorAll('[aria-busy="true"]'), function (element) {
      element.removeAttribute('aria-busy');
      element.classList.remove('is-inline-loading');
    });
  }

  function positionLogoEditor(entry) {
    if (!entry || !entry.card || !entry.frame) return false;
    var item = entry.card.closest('.swish-preview-column__item');
    var mediaWrapper = item && item.querySelector('.swish-preview-column__preview-wrapper');
    var slot = entry.card.querySelector('[data-swish-preview-order-frame-slot]');
    if (!item || !mediaWrapper || !slot || entry.frame.parentElement !== slot) return false;
    var itemRect = item.getBoundingClientRect();
    var mediaRect = mediaWrapper.getBoundingClientRect();
    slot.style.left = Math.max(0, mediaRect.left - itemRect.left) + 'px';
    slot.style.top = Math.max(0, mediaRect.top - itemRect.top) + 'px';
    slot.style.width = mediaRect.width + 'px';
    slot.style.height = mediaRect.height + 'px';
    return true;
  }

  function requestPlanPreview(entry) {
    if (!entry || !entry.card || !entry.frame || entry !== sharedEditorActiveEntry || entry.logoEditorActive || entry.pendingColorPreset) return;
    var navigation = getPreviewNavigation(entry.card);
    if (!navigation || getPreviewNavigationMode(navigation) !== '2d' || !entry.card.classList.contains('is-ready') || entry.card.dataset.swishPreviewOrderLoading === 'true') return;
    var media = navigation.item.querySelector('.swish-preview-column__preview-wrapper');
    if (!media) return;
    var box = media.getBoundingClientRect();
    if (!box.width || !box.height) return;
    var signature = [entry.card.dataset.swishPreviewOrderCurrentHash || entry.card.dataset.swishPreviewOrderHash,
      Math.round(box.width), Math.round(box.height), window.devicePixelRatio || 1].join('|');
    if (signature === entry.planSignature) return;
    entry.planSignature = signature;
    entry.planRequestId = (entry.planRequestId || 0) + 1;
    if (!entry.finishPlan) {
      var planDone = entry.planPromise = new Promise(function (resolve) { entry.finishPlan = resolve; });
      sharedEditorQueue = sharedEditorQueue.catch(function () {}).then(function () { return planDone; });
      entry.planTimer = setTimeout(function () {
        entry.planSignature = '';
        finishPlanRequest(entry);
      }, 15000);
    }
    entry.frame.contentWindow.postMessage({
      type: 'swish-preview-order-plan-render', id: entry.card.dataset.swishPreviewOrderMessageId,
      requestId: entry.planRequestId, width: Math.round(box.width), height: Math.round(box.height)
    }, '*');
  }

  function finishPlanRequest(entry) {
    clearTimeout(entry.planTimer);
    if (entry.finishPlan) entry.finishPlan();
    entry.finishPlan = null;
    if (entry.finishLoad && !entry.pendingHoopChange && !entry.awaitingHoopChange &&
      !(entry.logoEditorRequested && !entry.hasPreviewLogos)) entry.finishLoad();
  }

  function initializePlanPreview(navigation) {
    var media = navigation.item.querySelector('.swish-preview-column__preview-wrapper');
    if (!media || media.querySelector('[data-swish-preview-order-plan]')) return;
    var image = document.createElement('img');
    image.className = 'swish-preview-order-plan';
    image.setAttribute('data-swish-preview-order-plan', '');
    image.alt = '2D court design with total and key measurements and hoop overhang distances';
    image.hidden = true;
    var designLink = navigation.card.querySelector('[data-swish-preview-order-design]');
    var link = document.createElement('a');
    link.className = 'swish-preview-order-plan-link';
    link.setAttribute('data-swish-preview-order-plan-link', '');
    link.setAttribute('data-swishcb-preserve-link', '1');
    link.setAttribute('aria-label', 'Open this court in the court builder');
    link.href = designLink ? designLink.href : buildDesignUrl(navigation.card.dataset.swishPreviewOrderDesignUrl || '', navigation.card.dataset.swishPreviewOrderHash || '');
    if (designLink && designLink.target) link.target = designLink.target;
    if (designLink && designLink.rel) link.rel = designLink.rel;
    link.appendChild(image);
    media.appendChild(link);
    var status = document.createElement('span');
    status.className = 'swish-preview-order-plan-status';
    status.setAttribute('data-swish-preview-order-plan-status', '');
    status.setAttribute('role', 'status');
    status.textContent = 'Loading 2D previewâ€¦';
    media.appendChild(status);
    if (planResizeObserver) planResizeObserver.observe(media);
  }

  function enterLogoEditor(entry) {
    if (!entry || !entry.card || !entry.frame || !entry.frame.contentWindow) return false;
    if (!positionLogoEditor(entry)) return false;
    var item = entry.card.closest('.swish-preview-column__item');
    entry.logoEditorActive = true;
    if (logoEditorResizeObserver) {
      logoEditorResizeObserver.disconnect();
      logoEditorResizeObserver.observe(item);
      logoEditorResizeObserver.observe(item.querySelector('.swish-preview-column__preview-wrapper'));
    }
    entry.logoEditorRequested = false;
    item.classList.add('is-swish-preview-order-logo-editor-active');
    entry.card.classList.add('is-logo-editor-active');
    entry.frame.style.height = '100%';
    entry.frame.contentWindow.postMessage({
      type: 'swish-preview-order-logo-editor-mode',
      id: String(entry.card.dataset.swishPreviewOrderMessageId || ''),
      active: true
    }, '*');
    return true;
  }

  function exitLogoEditor(entry) {
    if (!entry || !entry.card) return false;
    var item = entry.card.closest('.swish-preview-column__item');
    var slot = entry.card.querySelector('[data-swish-preview-order-frame-slot]');
    entry.logoEditorActive = false;
    if (logoEditorResizeObserver) logoEditorResizeObserver.disconnect();
    entry.logoEditorRequested = false;
    if (item) item.classList.remove('is-swish-preview-order-logo-editor-active');
    entry.card.classList.remove('is-logo-editor-active');
    if (slot) {
      slot.style.removeProperty('left');
      slot.style.removeProperty('top');
      slot.style.removeProperty('width');
      slot.style.removeProperty('height');
    }
    if (entry.frame) entry.frame.style.removeProperty('height');
    if (entry.frame && entry.frame.contentWindow) {
      entry.frame.contentWindow.postMessage({
        type: 'swish-preview-order-logo-editor-mode',
        id: String(entry.card.dataset.swishPreviewOrderMessageId || ''),
        active: false
      }, '*');
    }
    refreshPreview(entry.card, entry.card.dataset.swishPreviewOrderCurrentHash || entry.card.dataset.swishPreviewOrderHash || '');
    return true;
  }

  function queueLogoFile(entry, trigger, file) {
    if (!entry || !entry.card || !file) return;
    showInlineLoading(entry.card, trigger);
    entry.logoEditorRequested = true;
    var navigation = getPreviewNavigation(entry.card);
    if (navigation) {
      navigation.toolbar.dataset.swishPreviewOrderViewMode = '2d';
      updatePreviewNavigationControls(navigation);
    }
    activatePreviewNavigation(entry.card);
    Promise.resolve(file.arrayBuffer()).then(function (buffer) {
      entry.pendingLogoFile = {
        name: String(file.name || 'court-logo'),
        type: String(file.type || 'application/octet-stream'),
        buffer: buffer
      };
      loadCard(entry.card);
    }).catch(function (error) {
      showError(entry.card, error);
    });
  }

  function sendPendingLogoFile(entry) {
    var pending = entry && entry.pendingLogoFile;
    if (!pending || !entry.frame || !entry.frame.contentWindow) return false;
    entry.pendingLogoFile = null;
    entry.frame.contentWindow.postMessage({
      type: 'swish-preview-order-logo-file',
      id: String(entry.card.dataset.swishPreviewOrderMessageId || ''),
      file: pending
    }, '*', [pending.buffer]);
    clearInlineLoading(entry.card);
    return true;
  }

  function showInlineLoading(card, target) {
    if (!card || !target) return;
    clearInlineLoading(card);
    var loading = document.createElement('span');
    loading.className = 'swish-preview-order-card__inline-loading';
    loading.setAttribute('data-swish-preview-order-inline-loading', '');
    loading.setAttribute('role', 'status');
    loading.setAttribute('aria-label', 'Loading court editor');
    loading.innerHTML = '<span class="swish-preview-order-card__inline-spinner" aria-hidden="true"></span><span>Loadingâ€¦</span>';
    target.setAttribute('aria-busy', 'true');
    target.classList.add('is-inline-loading');
    target.insertAdjacentElement('afterend', loading);
  }

  function getPreviewNavigation(card) {
    if (
      card &&
      card._swishPreviewOrderNavigation &&
      card._swishPreviewOrderNavigation.tile &&
      card._swishPreviewOrderNavigation.tile.isConnected
    ) {
      return card._swishPreviewOrderNavigation;
    }
    var item = card && card.closest('.swish-preview-column__item');
    var tile = item && item.querySelector('[data-swishcb-preview]');
    var toolbar = item && item.querySelector('[data-swish-preview-order-navigation]');
    if (!item || !tile || !toolbar) return null;
    card._swishPreviewOrderNavigation = { card: card, item: item, tile: tile, toolbar: toolbar };
    return card._swishPreviewOrderNavigation;
  }

  function getPreviewApi() {
    return window.SwishCB && window.SwishCB.previews;
  }

  function getPreviewNavigationMode(navigation) {
    var stored = String(navigation.toolbar.dataset.swishPreviewOrderViewMode || '').toLowerCase();
    if (stored === '2d' || stored === '3d') return stored;
    var hash = navigation.card.dataset.swishPreviewOrderCurrentHash || navigation.card.dataset.swishPreviewOrderHash || '';
    var requested = String(parseHash(hash).params.get('view') || '').toLowerCase();
    return requested === '2d' ? '2d' : '3d';
  }

  function updatePreviewNavigationControls(navigation) {
    if (!navigation) return;
    var mode = getPreviewNavigationMode(navigation);
    navigation.toolbar.dataset.swishPreviewOrderViewMode = mode;
    navigation.item.classList.toggle('is-swish-preview-order-2d', mode === '2d' && !navigation.toolbar.hidden);
    var surface = navigation.item.querySelector('[data-swish-preview-order-preview-link]');
    var canOrbit = mode === '3d' && !navigation.toolbar.hidden;
    navigation.item.classList.toggle('is-swish-preview-order-orbit-enabled', canOrbit);
    if (surface) {
      if (!surface.dataset.swishPreviewOriginalLabel) surface.dataset.swishPreviewOriginalLabel = surface.getAttribute('aria-label') || '';
      if (canOrbit) {
        surface.setAttribute('role', 'group');
        surface.setAttribute('tabindex', '0');
        surface.setAttribute('aria-label', 'Court preview: drag or use arrow keys to rotate the 3D view.');
      } else {
        surface.removeAttribute('role');
        surface.removeAttribute('tabindex');
        surface.setAttribute('aria-label', surface.dataset.swishPreviewOriginalLabel);
      }
    }
    Array.prototype.forEach.call(
      navigation.toolbar.querySelectorAll('[data-swish-preview-order-view]'),
      function (button) {
        var active = button.getAttribute('data-swish-preview-order-view') === mode;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    );
    Array.prototype.forEach.call(
      navigation.toolbar.querySelectorAll('[data-swish-preview-order-zoom]'),
      function (button) {
        button.disabled = mode === '2d';
      }
    );
  }

  function preparePreviewNavigationTile(navigation) {
    var hash = previewBasketballLineHash(navigation.card,
      navigation.card.dataset.swishPreviewOrderCurrentHash || navigation.card.dataset.swishPreviewOrderHash ||
      navigation.tile.getAttribute('data-swishcb-hash') || '');
    var parsed = parseHash(hash);
    if (String(parsed.params.get('view') || '').toLowerCase() === '2d') {
      parsed.params.set('view', '3d');
      parsed.params.set('ar', '0');
    }
    navigation.tile.setAttribute('data-swishcb-hash', parsed.params.toString());
  }

  function waitForPreviewApi(navigation, token, attempt) {
    return new Promise(function (resolve) {
      if (token !== navigation.activationSequence || !navigation.tile.isConnected) {
        resolve(null);
        return;
      }

      var previews = getPreviewApi();
      if (previews && typeof previews.pinTile === 'function') {
        try {
          if (typeof previews.init === 'function') previews.init();
        } catch (_) {}
        resolve(previews);
        return;
      }

      try {
        if (typeof window.__swishcbInitPreviews === 'function') window.__swishcbInitPreviews(navigation.item);
      } catch (_) {}

      if ((attempt || 0) >= 80) {
        resolve(null);
        return;
      }

      window.setTimeout(function () {
        waitForPreviewApi(navigation, token, (attempt || 0) + 1).then(resolve);
      }, 100);
    });
  }

  function pinPreviewNavigation(previews, navigation, token, attempt) {
    if (token !== navigation.activationSequence || !navigation.tile.isConnected) {
      return Promise.resolve(false);
    }
    return Promise.resolve(previews.pinTile(navigation.tile, {
      animate: false, includeHoops: true, loop: true, independent: true,
      autoRotateDegPerSec: PREVIEW_ORDER_ROTATE_DEG_PER_SEC
    }))
      .then(function (activated) {
        if (activated || token !== navigation.activationSequence || !navigation.tile.isConnected) {
          return !!activated;
        }
        if ((attempt || 0) >= 20) return false;
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            pinPreviewNavigation(previews, navigation, token, (attempt || 0) + 1).then(resolve);
          }, 250);
        });
      });
  }

  function activatePreviewNavigation(card, options) {
    var navigation = getPreviewNavigation(card);
    if (!navigation) return Promise.resolve(false);
    var settings = options || {};
    finishPreviewOrbit(true);
    // Preserve a customer's chosen orbit across color/dimension rebuilds.
    var currentApi = getPreviewApi();
    if (navigation.manualOrbit && navigation.lastPinnedMode !== '2d' && navigation.pinned && currentApi && currentApi.getPinnedView) {
      navigation.manualOrbit = currentApi.getPinnedView(navigation.tile) || navigation.manualOrbit;
    }
    navigation.orbitReady = false;

    navigation.toolbar.hidden = false;
    navigation.item.classList.add('has-swish-preview-order-navigation');
    preparePreviewNavigationTile(navigation);
    updatePreviewNavigationControls(navigation);

    navigation.item.classList.add('is-swish-preview-order-navigation-active');

    var token = navigation.activationSequence = (navigation.activationSequence || 0) + 1;
    if (getPreviewNavigationMode(navigation) === '2d') {
      navigation.lastPinnedMode = '2d';
      var entry = getCardEntry(card);
      var previews = getPreviewApi();
      if (previews && navigation.pinned && typeof previews.pausePinnedTile === 'function') {
        previews.pausePinnedTile(navigation.tile, { snap: false });
      }
      loadCard(card);
      return Promise.resolve(true);
    }
    navigation.activationQueue = (navigation.activationQueue || Promise.resolve())
      .catch(function () { return false; })
      .then(function () {
        return waitForPreviewApi(navigation, token, 0);
      })
      .then(function (previews) {
        if (!previews || token !== navigation.activationSequence || !navigation.tile.isConnected) return false;
        var activation = settings.forceReload === true && typeof previews.refreshPinnedTile === 'function'
          ? Promise.resolve(previews.refreshPinnedTile(navigation.tile, {
            animate: false, includeHoops: true, loop: true, independent: true,
            autoRotateDegPerSec: PREVIEW_ORDER_ROTATE_DEG_PER_SEC
          }))
          : pinPreviewNavigation(previews, navigation, token, 0);
        return activation
          .then(function (activated) {
            if (!activated || token !== navigation.activationSequence || !navigation.tile.isConnected) return false;
            navigation.pinned = true;
            var mode = getPreviewNavigationMode(navigation);
            if (typeof previews.setPinnedViewMode === 'function') previews.setPinnedViewMode(navigation.tile, mode);
            if (typeof previews.pausePinnedTile === 'function') previews.pausePinnedTile(navigation.tile, { snap: true });
            if (mode === '3d' && navigation.manualOrbit && typeof previews.orbitPinnedTile === 'function') {
              previews.orbitPinnedTile(navigation.tile, navigation.manualOrbit);
            }
            var colorGroup = getColorPresetGroup(card);
            if (colorGroup) syncColorPresetAngle(card, colorGroup);
            if (mode === '3d' && typeof previews.resumePinnedTile === 'function') previews.resumePinnedTile(navigation.tile);
            navigation.lastPinnedMode = mode;
            navigation.orbitReady = mode === '3d';
            return true;
          });
      })
      .catch(function (error) {
        console.error('[Swish preview ordering navigation]', error);
        return false;
      });

    return navigation.activationQueue;
  }

  function canOrbitPreview(navigation) {
    return navigation && navigation.orbitReady && navigation.tile.isConnected && navigation.pinned && !navigation.toolbar.hidden && getPreviewNavigationMode(navigation) === '3d';
  }

  function finishPreviewOrbit(resume) {
    var gesture = previewOrbitGesture;
    if (!gesture) return;
    previewOrbitGesture = null;
    gesture.navigation.suppressOrbitClickUntil = Date.now() + 500;
    gesture.navigation.item.classList.remove('is-swish-preview-order-orbit-dragging');
    try { gesture.surface.releasePointerCapture(gesture.pointerId); } catch (_) {}
    var previews = getPreviewApi();
    if (resume && gesture.resume && canOrbitPreview(gesture.navigation) && previews && previews.resumePinnedTile) {
      previews.resumePinnedTile(gesture.navigation.tile);
    }
  }

  function orbitPreviewBy(navigation, dx, dy) {
    var previews = getPreviewApi();
    var view = previews && previews.getPinnedView && previews.getPinnedView(navigation.tile);
    if (!view || !previews.orbitPinnedTile) return;
    // Match the main builder: one radian per 180 CSS pixels; same pitch limits.
    navigation.manualOrbit = previews.orbitPinnedTile(navigation.tile, {
      yaw: view.yaw + dx / 180,
      pitch: Math.max(0.1, Math.min(1.5, view.pitch + dy / 180)),
      roll: view.roll
    });
  }

  function initializePreviewOrbit(navigation) {
    var surface = navigation.item.querySelector('[data-swish-preview-order-preview-link]');
    if (!surface) return;
    surface.addEventListener('pointerdown', function (event) {
      if (!canOrbitPreview(navigation) || event.button > 0 || event.isPrimary === false) return;
      var previews = getPreviewApi();
      var view = previews && previews.getPinnedView && previews.getPinnedView(navigation.tile);
      if (!view || !previews.pausePinnedTile || !previews.orbitPinnedTile) return;
      finishPreviewOrbit(true);
      previews.pausePinnedTile(navigation.tile, { snap: false });
      previewOrbitGesture = {
        navigation: navigation, surface: surface, pointerId: event.pointerId,
        x: event.clientX, y: event.clientY, resume: view.autoRotate
      };
      navigation.item.classList.add('is-swish-preview-order-orbit-dragging');
      try { surface.setPointerCapture(event.pointerId); } catch (_) {}
      event.preventDefault();
    });
    surface.addEventListener('lostpointercapture', function (event) {
      if (previewOrbitGesture && previewOrbitGesture.pointerId === event.pointerId) finishPreviewOrbit(true);
    });
    // The resting preview remains a Design link; an interactive view is a drag surface.
    surface.addEventListener('click', function (event) {
      if ((!navigation.toolbar.hidden && getPreviewNavigationMode(navigation) === '3d') || Date.now() < (navigation.suppressOrbitClickUntil || 0)) {
        event.preventDefault(); event.stopPropagation();
      }
    }, true);
    surface.addEventListener('dragstart', function (event) {
      if (canOrbitPreview(navigation)) event.preventDefault();
    });
    surface.addEventListener('keydown', function (event) {
      if (!canOrbitPreview(navigation) || event.altKey || event.ctrlKey || event.metaKey) return;
      var delta = { ArrowLeft: [-18, 0], ArrowRight: [18, 0], ArrowUp: [0, -18], ArrowDown: [0, 18] }[event.key];
      if (!delta) return;
      event.preventDefault();
      var previews = getPreviewApi(), view = previews.getPinnedView(navigation.tile);
      if (!view) return;
      previews.pausePinnedTile(navigation.tile, { snap: false });
      orbitPreviewBy(navigation, delta[0], delta[1]);
      if (view.autoRotate) previews.resumePinnedTile(navigation.tile);
    });
  }

  window.addEventListener('pointermove', function (event) {
    var gesture = previewOrbitGesture;
    if (!gesture || gesture.pointerId !== event.pointerId) return;
    if (!canOrbitPreview(gesture.navigation)) { finishPreviewOrbit(false); return; }
    orbitPreviewBy(gesture.navigation, event.clientX - gesture.x, event.clientY - gesture.y);
    gesture.x = event.clientX;
    gesture.y = event.clientY;
    if (event.cancelable) event.preventDefault();
  }, { passive: false });
  ['pointerup', 'pointercancel'].forEach(function (name) {
    window.addEventListener(name, function (event) {
      if (previewOrbitGesture && previewOrbitGesture.pointerId === event.pointerId) finishPreviewOrbit(true);
    });
  });
  window.addEventListener('blur', function () { finishPreviewOrbit(true); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) finishPreviewOrbit(true); });
  document.addEventListener('shopify:section:unload', function (event) {
    if (previewOrbitGesture && event.target.contains(previewOrbitGesture.navigation.tile)) finishPreviewOrbit(false);
  });

  function initializePreviewNavigation(card) {
    var navigation = getPreviewNavigation(card);
    if (!navigation || navigation.toolbar.dataset.swishPreviewOrderNavigationReady === 'true') return;
    navigation.toolbar.dataset.swishPreviewOrderNavigationReady = 'true';
    initializePlanPreview(navigation);
    initializePreviewOrbit(navigation);
    updatePreviewNavigationControls(navigation);

    navigation.toolbar.addEventListener('click', function (event) {
      var zoom = event.target && event.target.closest
        ? event.target.closest('[data-swish-preview-order-zoom]')
        : null;
      var view = event.target && event.target.closest
        ? event.target.closest('[data-swish-preview-order-view]')
        : null;
      if (!zoom && !view) return;
      event.preventDefault();

      if (view) {
        var previousMode = getPreviewNavigationMode(navigation);
        navigation.toolbar.dataset.swishPreviewOrderViewMode =
          view.getAttribute('data-swish-preview-order-view') === '2d' ? '2d' : '3d';
        updatePreviewNavigationControls(navigation);
        var entry = getCardEntry(card);
        if (getPreviewNavigationMode(navigation) === '2d' && entry) {
          entry.logoEditorRequested = false;
          activatePreviewNavigation(card);
          return;
        }
        if (entry && entry.logoEditorActive) exitLogoEditor(entry);
        if (previousMode === '2d') {
          // The pinned 3D scene was paused while native 2D accepted edits.
          // Rebuild it from the current hash before showing that scene again.
          activatePreviewNavigation(card, { forceReload: true });
          return;
        }
      }

      var applyNavigationAction = function () {
        if (!navigation.pinned) return;
        var previews = getPreviewApi();
        if (!previews) return;
        if (view && typeof previews.setPinnedViewMode === 'function') {
          previews.setPinnedViewMode(navigation.tile, getPreviewNavigationMode(navigation));
          if (typeof previews.pausePinnedTile === 'function') previews.pausePinnedTile(navigation.tile, { snap: true });
          if (getPreviewNavigationMode(navigation) === '3d' && typeof previews.resumePinnedTile === 'function') previews.resumePinnedTile(navigation.tile);
          return;
        }
        if (
          zoom &&
          getPreviewNavigationMode(navigation) === '3d' &&
          typeof previews.zoomPinnedTile === 'function'
        ) {
          previews.zoomPinnedTile(
            navigation.tile,
            zoom.getAttribute('data-swish-preview-order-zoom') === 'in' ? 1 : -1
          );
          if (typeof previews.resumePinnedTile === 'function') previews.resumePinnedTile(navigation.tile);
        }
      };

      if (navigation.pinned) {
        applyNavigationAction();
        return;
      }
      activatePreviewNavigation(card).then(function (activated) {
        if (activated) applyNavigationAction();
      });
    });
  }

  function refreshPreview(card, hash) {
    var item = card.closest('.swish-preview-column__item');
    var tile = item && item.querySelector('[data-swishcb-preview]');
    if (!tile) return;
    tile.setAttribute('data-swishcb-hash', hash);

    // The editor's own 2D canvas draws the court and logo together. Rebuilding
    // the shared preview beneath it can race that handoff and show an empty
    // snapshot. Apply the latest hash when logo editing ends instead.
    var entry = getCardEntry(card);
    if (entry && (entry.logoEditorActive || entry.logoEditorRequested)) return;
    var planNavigation = getPreviewNavigation(card);
    if (planNavigation && getPreviewNavigationMode(planNavigation) === '2d' && !planNavigation.toolbar.hidden) {
      requestPlanPreview(entry);
      return;
    }

    var scope = tile.closest('[data-swishcb-preview-config]') || tile.parentElement;
    if (scope) scope.removeAttribute('data-swishcb-cover-src');
    var cover = tile.querySelector('[data-swishcb-cover]');
    if (cover) {
      cover.removeAttribute('src');
      cover.hidden = true;
    }

    try {
      if (window.SwishCB && window.SwishCB.previews && typeof window.SwishCB.previews.init === 'function') {
        window.SwishCB.previews.init();
      } else if (typeof window.__swishcbInitPreviews === 'function') {
        window.__swishcbInitPreviews();
      }
    } catch (_) {}

    var navigation = getPreviewNavigation(card);
    if (navigation && !navigation.toolbar.hidden && !(entry && entry.logoEditorActive)) {
      activatePreviewNavigation(card, { forceReload: true });
    }
  }

  function initializeRestingCardLink(card) {
    var item = card && card.closest ? card.closest('.swish-preview-column__item') : null;
    if (!item || item.dataset.swishPreviewOrderCardLinkReady === 'true') return;
    var destination = item.querySelector('[data-swish-preview-order-preview-link]');
    if (!destination) return;

    item.dataset.swishPreviewOrderCardLinkReady = 'true';
    item.classList.add('has-swish-preview-order-card-link');
    item.addEventListener('click', function (event) {
      if (item.classList.contains('is-swish-preview-order-navigation-active')) return;
      if (event.defaultPrevented || event.button > 0) return;

      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('a, button, input, select, textarea, label, iframe, [role="button"], [contenteditable="true"]')) return;

      var href = destination.href;
      if (!href) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey) {
        window.open(href, '_blank', 'noopener');
        return;
      }
      window.location.assign(href);
    });
  }

  function initializeCard(card) {
    if (!card || card.dataset.swishPreviewOrderReady === 'true') return;
    card.dataset.swishPreviewOrderReady = 'true';
    var messageId = String(card.dataset.swishPreviewOrderMessageId || '');
    var submit = card.querySelector('[data-swish-preview-order-submit]');
    var summary = card.querySelector('[data-swish-preview-order-summary]');
    if (!messageId) return;
    if (!card.dataset.swishPreviewOrderReferenceHash) {
      card.dataset.swishPreviewOrderReferenceHash = card.dataset.swishPreviewOrderHash || '';
    }
    card.dataset.swishPreviewOrderHash = previewBasketballLineHash(card, card.dataset.swishPreviewOrderHash || '');
    cardsByMessageId[messageId] = {
      card: card,
      frame: null,
      pendingEditor: '',
      pendingLogoFile: null,
      hasPreviewLogos: false,
      logoEditorRequested: false,
      logoEditorActive: false
    };
    configureOrderingPreviewTile(card);
    card._swishPreviewHoopMarkup = serializeHoopPurchaseUi(card);
    renderStaticSummary(card);
    initializePreviewNavigation(card);
    initializeRestingCardLink(card);
    initializeColorPresets(card);

    if (summary) {
      summary.addEventListener('click', function (event) {
        var edit = event.target && event.target.closest
          ? event.target.closest('[data-swish-preview-order-value-edit]')
          : null;
        if (!edit) return;
        var editor = String(edit.dataset.swishPreviewOrderEditor || '');
        var entry = cardsByMessageId[messageId];
        if (editor === 'logo') {
          entry.pendingEditor = '';
          event.preventDefault();
          var logoInput = card.querySelector('[data-swish-preview-order-logo-file]');
          if (logoInput) {
            logoInput.value = '';
            logoInput.click();
          }
          return;
        }
        if (entry.logoEditorActive || entry.logoEditorRequested) exitLogoEditor(entry);
        entry.pendingEditor = editor;
        showInlineLoading(card, edit);
        activatePreviewNavigation(card);
        loadCard(card);
      });

      summary.addEventListener('change', function (event) {
        var hoopControl = event.target && event.target.closest
          ? event.target.closest('[data-swishcb-hoop-purchase-toggle], [data-swishcb-hoop-purchase-select]') : null;
        if (hoopControl) {
          var entry = cardsByMessageId[messageId];
          if (entry.logoEditorActive || entry.logoEditorRequested) exitLogoEditor(entry);
          entry.pendingHoopChange = hoopControl.matches('[data-swishcb-hoop-purchase-toggle]')
            ? { active: hoopControl.checked } : { preset: hoopControl.value };
          showInlineLoading(card, hoopControl.closest('label') || hoopControl);
          activatePreviewNavigation(card);
          loadCard(card);
          return;
        }
        var input = event.target && event.target.closest
          ? event.target.closest('[data-swish-preview-order-logo-file]')
          : null;
        if (!input) return;
        var file = input.files && input.files[0];
        if (!file) return;
        var trigger = input.closest('[data-swish-preview-order-value-edit]') || input;
        queueLogoFile(cardsByMessageId[messageId], trigger, file);
      });

    }

    if (submit) {
      submit.addEventListener('click', function () {
        // The shared contact-popup listener handles this action. Do not load
        // the checkout editor or submit an order for a court above its limit.
        if (card.dataset.swishPreviewOrderCustomQuote === 'true') return;
        var entry = cardsByMessageId[messageId];
        var frame = entry && entry.frame;
        if (submit.disabled) return;
        setPreviewCheckoutLoading(card, true);
        if (card.classList.contains('is-ready') && !entry.pendingColorPreset && submitFrameOrder(entry, messageId)) {
          return;
        }
        card.dataset.swishPreviewOrderPendingSubmit = 'true';
        clearTimeout(entry.submitWaitTimer);
        entry.submitWaitTimer = setTimeout(function () {
          if (card.dataset.swishPreviewOrderPendingSubmit !== 'true') return;
          card.dataset.swishPreviewOrderPendingSubmit = 'false';
          showError(card, new Error('Court checkout is not ready yet. Please try again.'));
        }, 60000);
        loadCard(card);
      });
    }
  }

  var stickyStages = new Map();
  var stickyFrame = 0;
  var stickyResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleStickyPreviews) : null;

  function scheduleStickyPreviews() {
    if (!stickyStages.size || stickyFrame) return;
    stickyFrame = requestAnimationFrame(updateStickyPreviews);
  }

  function updateStickyPreviews() {
    stickyFrame = 0;
    var viewportHeight = window.innerHeight;
    stickyStages.forEach(function (state, stage) {
      if (!stage.isConnected) {
        if (stickyResizeObserver) { stickyResizeObserver.unobserve(stage); stickyResizeObserver.unobserve(state.card); }
        stickyStages.delete(stage);
        return;
      }
      var rect = stage.getBoundingClientRect();
      var cardRect = state.card.getBoundingClientRect();
      var top = (parseFloat(getComputedStyle(stage).getPropertyValue('--header-height')) || 0) + 12;
      // A featured card is stacked below this breakpoint. Pinning its preview
      // there would cover the information below it instead of sitting beside it.
      var stackedFeatured = window.innerWidth < 990 && state.card.closest('.swish-preview-order-column--featured');
      var fits = !stackedFeatured && rect.height + top + 100 < viewportHeight;
      var normalTop = rect.top - state.y;
      var y = fits ? Math.max(0, Math.min(top - normalTop, cardRect.bottom - normalTop - rect.height)) : 0;
      if (Math.abs(y - state.y) > 0.25) {
        stage.style.transform = y ? 'translateY(' + y + 'px)' : '';
        state.y = y;
        scheduleLogoEditorPosition();
      }
      stage.classList.toggle('is-swish-preview-sticky', y > 0);
      var height = fits ? Math.ceil(rect.height) + 'px' : '0px';
      if (state.height !== height) {
        state.card.style.setProperty('--swish-preview-sticky-height', height);
        state.height = height;
      }
    });
  }

  function initializeStickyPreviews(section) {
    if (section.dataset.swishPreviewOrderSticky !== 'true') return;
    section.querySelectorAll('[data-swish-preview-order-stage]').forEach(function (stage) {
      if (stickyStages.has(stage)) return;
      var card = stage.closest('.swish-preview-column__card--ordering');
      if (!card) return;
      stickyStages.set(stage, { card: card, y: 0 });
      if (stickyResizeObserver) { stickyResizeObserver.observe(stage); stickyResizeObserver.observe(card); }
    });
    scheduleStickyPreviews();
  }
  window.addEventListener('scroll', scheduleStickyPreviews, { passive: true });
  window.addEventListener('resize', scheduleStickyPreviews, { passive: true });
  document.addEventListener('shopify:section:unload', scheduleStickyPreviews);

  function initializeSection(section) {
    initializeStickyPreviews(section);
    if (!section || section.dataset.swishPreviewOrderingReady === 'true') return;
    section.dataset.swishPreviewOrderingReady = 'true';
    Array.prototype.forEach.call(section.querySelectorAll('[data-swish-preview-order-card]'), initializeCard);
  }

  function init(scope) {
    bindSummaryHelp(window);
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-swish-preview-order-column]')) initializeSection(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-swish-preview-order-column]'), initializeSection);
  }

  // Clicks inside the editor iframe do not reach this document. Dismiss on
  // click (including keyboard activation), after the original target receives
  // pointerdown/focus, so restoring the summary cannot swallow its activation.
  function dismissOutsideLogoEditor(event) {
    var entry = sharedEditorActiveEntry;
    if (!entry || !entry.logoEditorActive) return;
    if (entry.frame && event.target === entry.frame) return;
    exitLogoEditor(entry);
  }
  document.addEventListener('click', dismissOutsideLogoEditor, true);

  window.addEventListener('message', function (event) {
    if (event.origin !== window.location.origin) return;
    var data = event.data || {};
    var entry = cardsByMessageId[String(data.id || '')];
    if (!entry || !entry.frame || event.source !== entry.frame.contentWindow) return;

    if (data.type === 'swish-preview-order-fetch') {
      proxyPreviewOrderFetch(entry, data);
      return;
    }

    if (data.type === 'swish-preview-order-logo-picker') {
      var logoInput = entry.card.querySelector('[data-swish-preview-order-logo-file]');
      if (logoInput) {
        logoInput.value = '';
        logoInput.click();
      }
      return;
    }

    if (data.type === 'swish-preview-order-runtime-error') {
      if (entry.finishLoad) entry.finishLoad(new Error(String(data.message || 'Court editor failed to initialize.')));
      finishPlanRequest(entry);
      showError(entry.card, new Error(String(data.message || 'Court editor failed to initialize.')));
      return;
    }

    if (data.type === 'swish-preview-order-plan-image') {
      if (Number(data.requestId) !== entry.planRequestId || !/^data:image\/png;base64,/.test(String(data.image || ''))) return;
      var navigation = getPreviewNavigation(entry.card);
      var image = navigation && navigation.item.querySelector('[data-swish-preview-order-plan]');
      if (!image) return;
      image.src = data.image;
      image.hidden = false;
      var status = navigation.item.querySelector('[data-swish-preview-order-plan-status]');
      if (status) status.hidden = true;
      finishPlanRequest(entry);
      return;
    }

    if (data.type === 'swish-preview-order-height') {
      if (entry.logoEditorActive) return;
      var height = Number(data.height);
      if (!Number.isFinite(height) || height <= 0) return;
      height = Math.max(120, height);
      if (entry.frame.style.height !== height + 'px') entry.frame.style.height = height + 'px';
      scheduleLogoEditorPosition();
      return;
    }

    if (data.type === 'swish-preview-order-state') {
      // A previous editor snapshot must not undo a more recent swatch click.
      if (entry.pendingColorPreset && Number(data.colorPresetRequestId) !== entry.pendingColorPreset.requestId) return;
      entry.awaitingHoopChange = false;
      if (entry.pendingColorPreset) {
        entry.pendingColorPreset = null;
        var colorGroup = getColorPresetGroup(entry.card);
        if (colorGroup) {
          colorGroup.removeAttribute('aria-busy');
          colorGroup.querySelector('[data-swish-preview-order-colors-status]').textContent = 'Court colors updated.';
        }
      }
      var originalHash = entry.card.dataset.swishPreviewOrderHash || '';
      var hash = restoreDesignView(data.hash || originalHash, originalHash);
      hash = previewBasketballLineHash(entry.card, hash);
      hash = applyPreviewLogoManifest(entry, hash, data.logos);
      var previousHash = entry.card.dataset.swishPreviewOrderCurrentHash || originalHash;
      var hasReceivedInitialState = entry.card.dataset.swishPreviewOrderInitialState === 'true';
      var submit = entry.card.querySelector('[data-swish-preview-order-submit]');
      entry.card.dataset.swishPreviewOrderCurrentHash = hash;
      entry.card.dataset.swishPreviewOrderInitialState = 'true';
      entry.card.dataset.swishPreviewOrderLoading = 'false';
      entry.card.classList.add('is-ready');
      entry.card.classList.remove('is-loading', 'has-error');
      if (data.summary && typeof data.summary === 'object') {
        entry.card._swishPreviewOrderCanonicalSummary = data.summary;
      }
      if (data.dimensionsEdited === true) entry.card._swishPreviewOrderDimensionsEdited = true;
      entry.hasPreviewLogos = Array.isArray(data.logos) && data.logos.length > 0;
      renderStaticSummary(entry.card);
      refreshActiveCardPresentation();
      updateDesignLinks(entry.card, hash);
      if (submit && entry.card.dataset.swishPreviewOrderCheckoutLoading !== 'true') {
        submit.disabled = !data.canOrder && entry.card.dataset.swishPreviewOrderCustomQuote !== 'true';
      }
      // The first state received from the shared editor can already contain a
      // customer edit (fast typists can commit before the initial bridge
      // snapshot reaches the parent). Always rebuild when the canonical hash
      // differs from the card's previous hash, including that first message.
      if (hash !== previousHash) refreshPreview(entry.card, hash);
      if (entry.pendingEditor && entry.frame.contentWindow) {
        var pendingEditor = entry.pendingEditor;
        entry.pendingEditor = '';
        entry.frame.contentWindow.postMessage({
          type: 'swish-preview-order-open-editor',
          id: String(data.id || ''),
          editor: pendingEditor
        }, '*');
        clearInlineLoading(entry.card);
      }
      sendPendingLogoFile(entry);
      if (entry.logoEditorRequested && entry.hasPreviewLogos) {
        enterLogoEditor(entry);
      } else if (entry.logoEditorActive && !entry.hasPreviewLogos) {
        exitLogoEditor(entry);
      }
      requestPlanPreview(entry);
      if (entry.finishLoad && !entry.finishPlan && !entry.pendingHoopChange &&
        !(entry.logoEditorRequested && !entry.hasPreviewLogos)) entry.finishLoad();
      if (entry.pendingHoopChange && entry.frame.contentWindow) {
        var hoopChange = entry.pendingHoopChange;
        entry.pendingHoopChange = null;
        entry.awaitingHoopChange = true;
        entry.frame.contentWindow.postMessage({ type: 'swish-preview-order-hoop-change', id: String(data.id || ''), change: hoopChange }, '*');
        clearInlineLoading(entry.card);
      }
      if (data.canOrder && entry.card.dataset.swishPreviewOrderPendingSubmit === 'true' && entry.frame) {
        clearTimeout(entry.submitWaitTimer);
        entry.card.dataset.swishPreviewOrderPendingSubmit = 'false';
        submitFrameOrder(entry, data.id);
      }
      // Early editor snapshots can precede price/eligibility initialization.
      // Keep the customer's click queued until a ready snapshot or timeout.
      return;
    }

    if (data.type === 'swish-preview-order-checkout') {
      try {
        var checkoutUrl = new URL(String(data.url || ''), window.location.origin);
        if (checkoutUrl.protocol === 'https:') {
          entry.card.dataset.swishPreviewOrderCheckoutReady = 'true';
          window.location.assign(checkoutUrl.href);
        }
      } catch (error) {
        setPreviewCheckoutLoading(entry.card, false);
        console.error('[Swish preview ordering card] Invalid checkout URL', error);
      }
      return;
    }

    if (data.type === 'swish-preview-order-checkout-failed') {
      setPreviewCheckoutLoading(entry.card, false);
      return;
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-swish-preview-order-colors]').forEach(function (group) {
      if (group._swishColorSlider && group._swishColorSlider.observer) group._swishColorSlider.observer.disconnect();
    });
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.SwishPreviewColumnOrdering = { init: init, bindSummaryHelp: bindSummaryHelp };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
